// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";
// import { collection, query, where, getDocs, orderBy, limit, Timestamp } from "firebase/firestore";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import DashboardLayout from "../../components/layout/DashboardLayout";
// import StatsCard from "../../components/dashboard/StatsCard";
// import SalesChart from "../../components/dashboard/SalesChart";
// import OrdersTable from "../../components/dashboard/OrdersTable";
// import ProductsTable from "../../components/dashboard/ProductsTable";
// import { useAuth } from "../../contexts/AuthContext";
// import { db } from "../../services/firebase";

// const DashboardPage = () => {
//   const { currentUser, vendorProfile } = useAuth();
//   const [dashboardData, setDashboardData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [dateRange, setDateRange] = useState("week"); // 'day', 'week', 'month', 'year', 'custom'
//   const [customDateRange, setCustomDateRange] = useState([null, null]); // [startDate, endDate]
//   const [startDate, endDate] = customDateRange;

//   // Calculate date range based on selected option
//   const getDateRangeTimestamp = () => {
//     const now = new Date();
//     let startDate, endDate;

//     if (dateRange === "custom" && customDateRange[0] && customDateRange[1]) {
//       startDate = new Date(customDateRange[0]);
//       endDate = new Date(customDateRange[1]);
//       // Set end date to end of day
//       endDate.setHours(23, 59, 59, 999);
//     } else {
//       endDate = new Date(); // Current time

//       switch (dateRange) {
//         case "day":
//           startDate = new Date(now);
//           startDate.setHours(0, 0, 0, 0);
//           break;
//         case "week":
//           startDate = new Date(now);
//           startDate.setDate(now.getDate() - 7);
//           startDate.setHours(0, 0, 0, 0);
//           break;
//         case "month":
//           startDate = new Date(now);
//           startDate.setMonth(now.getMonth() - 1);
//           startDate.setHours(0, 0, 0, 0);
//           break;
//         case "year":
//           startDate = new Date(now);
//           startDate.setFullYear(now.getFullYear() - 1);
//           startDate.setHours(0, 0, 0, 0);
//           break;
//         default:
//           startDate = new Date(now);
//           startDate.setDate(now.getDate() - 7);
//           startDate.setHours(0, 0, 0, 0);
//       }
//     }

//     return {
//       start: Timestamp.fromDate(startDate),
//       end: Timestamp.fromDate(endDate)
//     };
//   };

//   // Fetch dashboard data from Firestore
//   useEffect(() => {
//     const fetchDashboardData = async () => {
//       if (!currentUser?.uid) return;

//       setLoading(true);
//       setError("");

//       try {
//         const { start, end } = getDateRangeTimestamp();

//         // Fetch current period orders
//         const ordersQuery = query(
//           collection(db, "orders"),
//           where("vendorId", "==", currentUser.uid),
//           where("createdAt", ">=", start),
//           where("createdAt", "<=", end),
//           orderBy("createdAt", "desc")
//         );

//         const ordersSnapshot = await getDocs(ordersQuery);
//         const orders = ordersSnapshot.docs.map(doc => ({
//           id: doc.id,
//           ...doc.data(),
//           date: doc.data().createdAt.toDate().toISOString().split('T')[0]
//         }));

//         // Fetch previous period orders for comparison
//         const periodLength = end.toDate().getTime() - start.toDate().getTime();
//         const prevStart = new Date(start.toDate().getTime() - periodLength);
//         const prevEnd = start.toDate();

//         const prevOrdersQuery = query(
//           collection(db, "orders"),
//           where("vendorId", "==", currentUser.uid),
//           where("createdAt", ">=", Timestamp.fromDate(prevStart)),
//           where("createdAt", "<", Timestamp.fromDate(prevEnd)),
//           orderBy("createdAt", "desc")
//         );

//         const prevOrdersSnapshot = await getDocs(prevOrdersQuery);
//         const previousOrders = prevOrdersSnapshot.docs.map(doc => ({
//           id: doc.id,
//           ...doc.data()
//         }));

//         // Calculate enhanced statistics
//         const stats = calculateStatistics(orders, previousOrders);

//         // Get order status counts
//         const pendingOrders = orders.filter(order =>
//           order.status === "Pending" || order.status === "Processing"
//         ).length;

//         // Fetch products
//         const productsQuery = query(
//           collection(db, "products"),
//           where("vendorId", "==", currentUser.uid)
//         );

//         const productsSnapshot = await getDocs(productsQuery);
//         const products = productsSnapshot.docs.map(doc => ({
//           id: doc.id,
//           ...doc.data()
//         }));

//         // Calculate product stats
//         const totalProducts = products.length;
//         const lowStockProducts = products.filter(product =>
//           (product.stock || 0) < (product.lowStockThreshold || 10)
//         ).length;

//         // Get top products by sales
//         const topProducts = products
//           .sort((a, b) => (b.totalSales || 0) - (a.totalSales || 0))
//           .slice(0, 5)
//           .map(product => ({
//             id: product.id,
//             name: product.name,
//             sku: product.sku || 'N/A',
//             stock: product.stock || 0,
//             sales: product.totalSales || 0
//           }));

//         // Prepare sales data for chart with proper grouping
//         const salesByDate = orders.reduce((acc, order) => {
//           const date = order.date;
//           if (!acc[date]) {
//             acc[date] = 0;
//           }
//           acc[date] += order.totalAmount || 0;
//           return acc;
//         }, {});

//         // Fill in missing dates with zero sales
//         const salesData = [];
//         const currentDate = new Date(start.toDate());
//         const endDate = new Date(end.toDate());

//         while (currentDate <= endDate) {
//           const dateStr = currentDate.toISOString().split('T')[0];
//           salesData.push({
//             date: dateStr,
//             sales: salesByDate[dateStr] || 0
//           });
//           currentDate.setDate(currentDate.getDate() + 1);
//         }

//         // Format recent orders for table
//         const recentOrders = orders
//           .slice(0, 5)
//           .map(order => ({
//             id: order.id,
//             customerName: order.customerName || 'Unknown',
//             total: order.totalAmount || 0,
//             status: order.status || 'Pending',
//             date: order.date
//           }));

//         // Fetch customers (based on unique customer IDs in orders)
//         const uniqueCustomerIds = [...new Set(orders.map(order => order.customerId).filter(Boolean))];
//         const totalCustomers = uniqueCustomerIds.length;

//         // Mock visitor data (replace with actual analytics when available)
//         let visitorsToday = Math.floor(Math.random() * 200) + 50;

//         // Compile dashboard data with enhanced statistics
//         const dashboardData = {
//           stats: {
//             totalSales: stats.totalSales,
//             totalOrders: stats.totalOrders,
//             averageOrderValue: stats.averageOrderValue,
//             totalCustomers,
//             totalProducts,
//             lowStockProducts,
//             pendingOrders,
//             visitorsToday,
//             // Add comparison data
//             salesChange: stats.salesChange,
//             ordersChange: stats.ordersChange,
//             salesTrend: stats.salesTrend,
//             ordersTrend: stats.ordersTrend
//           },
//           salesData: salesData.length > 0 ? salesData : generateMockSalesData(),
//           recentOrders,
//           topProducts
//         };

//         setDashboardData(dashboardData);
//       } catch (error) {
//         console.error("Error fetching dashboard data:", error);
//         setError("Failed to load dashboard data. Please check your connection and try again.");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchDashboardData();
//   }, [currentUser, dateRange, customDateRange]);


//   const calculateStatistics = (orders, previousOrders = []) => {
//     const totalOrders = orders.length;
//     const totalSales = orders.reduce((sum, order) => sum + (order.totalAmount || 0), 0);
//     const averageOrderValue = totalOrders > 0 ? totalSales / totalOrders : 0;

//     // Previous period stats for comparison
//     const prevTotalOrders = previousOrders.length;
//     const prevTotalSales = previousOrders.reduce((sum, order) => sum + (order.totalAmount || 0), 0);

//     // Calculate percentage changes
//     const salesChange = prevTotalSales > 0 ?
//       ((totalSales - prevTotalSales) / prevTotalSales) * 100 : 0;
//     const ordersChange = prevTotalOrders > 0 ?
//       ((totalOrders - prevTotalOrders) / prevTotalOrders) * 100 : 0;

//     return {
//       totalSales,
//       totalOrders,
//       averageOrderValue,
//       salesChange: Math.round(salesChange * 10) / 10, // Round to 1 decimal
//       ordersChange: Math.round(ordersChange * 10) / 10,
//       salesTrend: salesChange >= 0 ? 'up' : 'down',
//       ordersTrend: ordersChange >= 0 ? 'up' : 'down'
//     };
//   };
//   // Generate mock sales data if no orders exist
//   const generateMockSalesData = () => {
//     const data = [];
//     const today = new Date();
//     for (let i = 6; i >= 0; i--) {
//       const date = new Date(today);
//       date.setDate(date.getDate() - i);
//       data.push({
//         date: date.toISOString().split('T')[0],
//         sales: Math.floor(Math.random() * 1500) + 500
//       });
//     }
//     return data;
//   };

//   // Format currency
//   const formatCurrency = (amount) => {
//     return new Intl.NumberFormat("en-IN", {
//       style: "currency",
//       currency: "INR",
//       maximumFractionDigits: 0,
//     }).format(amount);
//   };

//   return (
//     <DashboardLayout>
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         {/* Dashboard Header */}
//         <div className="py-4 border-b border-gray-200">
//           <div className="flex items-center justify-between">
//             <div>
//               <h1 className="text-2xl font-bold text-gray-900">Vendor Dashboard</h1>
//               <p className="mt-1 text-sm text-gray-600">
//                 Welcome back, {vendorProfile?.shopName || currentUser?.displayName || "Vendor"}!
//               </p>
//             </div>
//             <div className="hidden sm:flex items-center space-x-2 text-sm text-gray-600">
//               <span>{new Date().toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}</span>
//               <span>•</span>
//               <span>Last login: {new Date().toLocaleDateString()}</span>
//             </div>
//           </div>
//         </div>

//         {loading ? (
//           <div className="animate-pulse space-y-6 py-6">
//             <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
//               {[...Array(4)].map((_, index) => (
//                 <div
//                   key={index}
//                   className="bg-white overflow-hidden shadow rounded-lg h-32"
//                 ></div>
//               ))}
//             </div>
//             <div className="bg-white overflow-hidden shadow rounded-lg h-80"></div>
//             <div className="grid grid-cols-1 gap-5 lg:grid-cols-2">
//               <div className="bg-white overflow-hidden shadow rounded-lg h-96"></div>
//               <div className="bg-white overflow-hidden shadow rounded-lg h-96"></div>
//             </div>
//           </div>
//         ) : error ? (
//           <div className="bg-red-50 border border-red-200 rounded-md p-6 my-6">
//             <div className="flex">
//               <div className="flex-shrink-0">
//                 <svg
//                   className="h-6 w-6 text-red-400"
//                   xmlns="http://www.w3.org/2000/svg"
//                   viewBox="0 0 20 20"
//                   fill="currentColor"
//                 >
//                   <path
//                     fillRule="evenodd"
//                     d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
//                     clipRule="evenodd"
//                   />
//                 </svg>
//               </div>
//               <div className="ml-3">
//                 <h3 className="text-lg font-medium text-red-800">Error Loading Dashboard</h3>
//                 <div className="mt-2 text-base text-red-700">
//                   <p>{error}</p>
//                   <button
//                     onClick={() => window.location.reload()}
//                     className="mt-3 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
//                   >
//                     <svg className="mr-2 h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
//                     </svg>
//                     Refresh Page
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         ) : dashboardData ? (
//           <div className="space-y-6 py-6">



//             {/* Quick Actions */}
//             <div className="bg-white overflow-hidden shadow-lg rounded-lg transition-shadow duration-300 hover:shadow-xl">
//               <div className="px-4 py-5 sm:p-6">
//                 <h3 className="text-lg font-medium leading-6 text-gray-900 mb-4">
//                   Quick Actions
//                 </h3>
//                 <div className="grid grid-cols-2 gap-4 sm:grid-cols-2 lg:grid-cols-4">
//                   <Link
//                     to="/inventory/add"
//                     className="flex items-center justify-center px-4 py-4 border border-transparent text-sm font-medium rounded-lg shadow-sm text-white bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 transition-all duration-300"
//                   >
//                     <svg
//                       xmlns="http://www.w3.org/2000/svg"
//                       className="h-5 w-5 mr-2"
//                       viewBox="0 0 20 20"
//                       fill="currentColor"
//                     >
//                       <path
//                         fillRule="evenodd"
//                         d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z"
//                         clipRule="evenodd"
//                       />
//                     </svg>
//                     Add Product
//                   </Link>
//                   <Link
//                     to="/orders?status=pending"
//                     className="flex items-center justify-center px-4 py-4 border border-transparent text-sm font-medium rounded-lg shadow-sm text-white bg-gradient-to-r from-indigo-500 to-indigo-600 hover:from-indigo-600 hover:to-indigo-700 transition-all duration-300"
//                   >
//                     <svg
//                       xmlns="http://www.w3.org/2000/svg"
//                       className="h-5 w-5 mr-2"
//                       viewBox="0 0 20 20"
//                       fill="currentColor"
//                     >
//                       <path d="M3 1a1 1 0 000 2h1.22l.305 1.222a.997.997 0 00.01.042l1.358 5.43-.893.892C3.74 11.846 4.632 14 6.414 14H15a1 1 0 000-2H6.414l1-1H14a1 1 0 00.894-.553l3-6A1 1 0 0017 3H6.28l-.31-1.243A1 1 0 005 1H3zM16 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM6.5 18a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" />
//                     </svg>
//                     Process Orders
//                   </Link>
//                   <Link
//                     to="/inventory?stock=low"
//                     className="flex items-center justify-center px-4 py-4 border border-transparent text-sm font-medium rounded-lg shadow-sm text-white bg-gradient-to-r from-yellow-500 to-yellow-600 hover:from-yellow-600 hover:to-yellow-700 transition-all duration-300"
//                   >
//                     <svg
//                       xmlns="http://www.w3.org/2000/svg"
//                       className="h-5 w-5 mr-2"
//                       viewBox="0 0 20 20"
//                       fill="currentColor"
//                     >
//                       <path
//                         fillRule="evenodd"
//                         d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
//                         clipRule="evenodd"
//                       />
//                     </svg>
//                     Low Stock Items
//                   </Link>
//                   <Link
//                     to="/communication"
//                     className="flex items-center justify-center px-4 py-4 border border-transparent text-sm font-medium rounded-lg shadow-sm text-white bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 transition-all duration-300"
//                   >
//                     <svg
//                       xmlns="http://www.w3.org/2000/svg"
//                       className="h-5 w-5 mr-2"
//                       viewBox="0 0 20 20"
//                       fill="currentColor"
//                     >
//                       <path d="M2 5a2 2 0 012-2h7a2 2 0 012 2v4a2 2 0 01-2 2H9l-3 3v-3H4a2 2 0 01-2-2V5z" />
//                       <path d="M15 7v2a4 4 0 01-4 4H9.828l-1.766 1.767c.28.149.599.233.938.233h2l3 3v-3h2a2 2 0 002-2V9a2 2 0 00-2-2h-1z" />
//                     </svg>
//                     Customer Messages
//                   </Link>
//                 </div>
//               </div>
//             </div>


//             {/* Date range selector */}
//             <div className="flex justify-end items-center space-x-4">
//               <div className="inline-flex shadow-sm rounded-md">
//                 <button
//                   type="button"
//                   className={`px-4 py-2 text-sm font-medium rounded-l-md ${dateRange === "day"
//                     ? "bg-orange-600 text-white"
//                     : "bg-white text-gray-700 hover:bg-gray-50"
//                     } border border-gray-300 focus:z-10 focus:outline-none focus:ring-1 focus:ring-orange-500`}
//                   onClick={() => {
//                     setDateRange("day");
//                     setCustomDateRange([null, null]);
//                   }}
//                 >
//                   Today
//                 </button>
//                 <button
//                   type="button"
//                   className={`px-4 py-2 text-sm font-medium ${dateRange === "week"
//                     ? "bg-orange-600 text-white"
//                     : "bg-white text-gray-700 hover:bg-gray-50"
//                     } border-t border-b border-gray-300 focus:z-10 focus:outline-none focus:ring-1 focus:ring-orange-500`}
//                   onClick={() => {
//                     setDateRange("week");
//                     setCustomDateRange([null, null]);
//                   }}
//                 >
//                   Week
//                 </button>
//                 <button
//                   type="button"
//                   className={`px-4 py-2 text-sm font-medium ${dateRange === "month"
//                     ? "bg-orange-600 text-white"
//                     : "bg-white text-gray-700 hover:bg-gray-50"
//                     } border-t border-b border-gray-300 focus:z-10 focus:outline-none focus:ring-1 focus:ring-orange-500`}
//                   onClick={() => {
//                     setDateRange("month");
//                     setCustomDateRange([null, null]);
//                   }}
//                 >
//                   Month
//                 </button>
//                 <button
//                   type="button"
//                   className={`px-4 py-2 text-sm font-medium rounded-r-md ${dateRange === "year"
//                     ? "bg-orange-600 text-white"
//                     : "bg-white text-gray-700 hover:bg-gray-50"
//                     } border border-gray-300 focus:z-10 focus:outline-none focus:ring-1 focus:ring-orange-500`}
//                   onClick={() => {
//                     setDateRange("year");
//                     setCustomDateRange([null, null]);
//                   }}
//                 >
//                   Year
//                 </button>
//               </div>
//               <div className="relative">
//                 <DatePicker
//                   selectsRange={true}
//                   startDate={startDate}
//                   endDate={endDate}
//                   onChange={(update) => {
//                     setCustomDateRange(update);
//                     if (update[0] && update[1]) {
//                       setDateRange("custom");
//                     }
//                   }}
//                   isClearable={true}
//                   placeholderText="Select custom range"
//                   className="px-4 py-2 text-sm font-medium border border-gray-300 rounded-md bg-white text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-1 focus:ring-orange-500"
//                 />
//               </div>
//             </div>

//             {/* Stats Cards */}
//             <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
//               <StatsCard
//                 title="Total Sales"
//                 value={formatCurrency(dashboardData.stats.totalSales)}
//                 icon={
//                   <svg
//                     xmlns="http://www.w3.org/2000/svg"
//                     className="h-6 w-6 text-orange-600"
//                     fill="none"
//                     viewBox="0 0 24 24"
//                     stroke="currentColor"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
//                     />
//                   </svg>
//                 }
//                 change={dashboardData.stats.salesChange}
//                 trend={dashboardData.stats.salesTrend}
//               />
//               <StatsCard
//                 title="Total Orders"
//                 value={dashboardData.stats.totalOrders}
//                 icon={
//                   <svg
//                     xmlns="http://www.w3.org/2000/svg"
//                     className="h-6 w-6 text-indigo-600"
//                     fill="none"
//                     viewBox="0 0 24 24"
//                     stroke="currentColor"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"
//                     />
//                   </svg>
//                 }
//                 change={dashboardData.stats.ordersChange}
//                 trend={dashboardData.stats.ordersTrend}
//               />
//               <StatsCard
//                 title="Pending Orders"
//                 value={dashboardData.stats.pendingOrders}
//                 icon={
//                   <svg
//                     xmlns="http://www.w3.org/2000/svg"
//                     className="h-6 w-6 text-yellow-600"
//                     fill="none"
//                     viewBox="0 0 24 24"
//                     stroke="currentColor"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
//                     />
//                   </svg>
//                 }
//                 change={0} // Static for now
//                 trend="neutral"
//               />
//               {/* <StatsCard
//                 title="Total Product Views"
//                 value={dashboardData.stats.visitorsToday}
//                 icon={
//                   <svg
//                     xmlns="http://www.w3.org/2000/svg"
//                     className="h-6 w-6 text-green-600"
//                     fill="none"
//                     viewBox="0 0 24 24"
//                     stroke="currentColor"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
//                     />
//                   </svg>
//                 }
//                 change={5.8}
//                 trend="up"
//               /> */}
//             </div>

//             {/* Sales Chart */}
//             <div className="bg-white overflow-hidden shadow-lg rounded-lg transition-shadow duration-300 hover:shadow-xl">
//               <div className="px-4 py-5 sm:p-6">
//                 <div className="flex items-center justify-between mb-4">
//                   <h3 className="text-lg font-medium leading-6 text-gray-900">
//                     Sales Overview
//                   </h3>
//                   <div className="flex items-center text-sm text-gray-500">
//                     <span className="inline-block w-3 h-3 bg-orange-500 rounded-full mr-1"></span>
//                     <span>Revenue</span>
//                   </div>
//                 </div>
//                 <div className="h-80">
//                   <SalesChart data={dashboardData.salesData} />
//                 </div>
//               </div>
//             </div>

//             {/* Orders and Products Tables */}
//             <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
//               {/* Recent Orders */}
//               <div className="bg-white overflow-hidden shadow-lg rounded-lg transition-shadow duration-300 hover:shadow-xl">
//                 <div className="px-4 py-5 sm:px-6 flex justify-between items-center border-b border-gray-200">
//                   <h3 className="text-lg font-medium leading-6 text-gray-900">
//                     Recent Orders
//                   </h3>
//                   <Link
//                     to="/orders"
//                     className="text-sm font-medium text-orange-600 hover:text-orange-500 flex items-center"
//                   >
//                     View all
//                     <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1" viewBox="0 0 20 20" fill="currentColor">
//                       <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
//                     </svg>
//                   </Link>
//                 </div>
//                 <div className="px-4 py-3 sm:px-6">
//                   {dashboardData.recentOrders.length > 0 ? (
//                     <OrdersTable orders={dashboardData.recentOrders} />
//                   ) : (
//                     <div className="py-6 text-center text-gray-500">
//                       <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 mx-auto text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
//                       </svg>
//                       <p className="mt-2">No orders yet</p>
//                       <Link to="/orders/new" className="mt-3 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-orange-600 hover:bg-orange-700">
//                         Create your first order
//                       </Link>
//                     </div>
//                   )}
//                 </div>
//               </div>

//               {/* Top Products */}
//               <div className="bg-white overflow-hidden shadow-lg rounded-lg transition-shadow duration-300 hover:shadow-xl">
//                 <div className="px-4 py-5 sm:px-6 flex justify-between items-center border-b border-gray-200">
//                   <h3 className="text-lg font-medium leading-6 text-gray-900">
//                     Top Products
//                   </h3>
//                   <Link
//                     to="/inventory"
//                     className="text-sm font-medium text-orange-600 hover:text-orange-500 flex items-center"
//                   >
//                     View all
//                     <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1" viewBox="0 0 20 20" fill="currentColor">
//                       <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
//                     </svg>
//                   </Link>
//                 </div>
//                 <div className="px-4 py-3 sm:px-6">
//                   {dashboardData.topProducts.length > 0 ? (
//                     <ProductsTable products={dashboardData.topProducts} />
//                   ) : (
//                     <div className="py-6 text-center text-gray-500">
//                       <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 mx-auto text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
//                       </svg>
//                       <p className="mt-2">No products yet</p>
//                       <Link to="/inventory/add" className="mt-3 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-orange-600 hover:bg-orange-700">
//                         Add your first product
//                       </Link>
//                     </div>
//                   )}
//                 </div>
//               </div>
//             </div>



//             {/* Additional Insights Section */}
//             <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
//               {/* Inventory Status */}
//               <div className="bg-white overflow-hidden shadow-lg rounded-lg transition-shadow duration-300 hover:shadow-xl">
//                 <div className="bg-gradient-to-r from-orange-50 to-indigo-50 px-4 py-3 border-b border-gray-200">
//                   <h3 className="text-base font-medium text-gray-900 flex items-center">
//                     <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2 text-orange-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
//                     </svg>
//                     Inventory Status
//                   </h3>
//                 </div>
//                 <div className="px-4 py-4">
//                   <div className="flex justify-between items-center mb-3">
//                     <span className="text-sm text-gray-500">Total Products</span>
//                     <span className="text-lg font-semibold">{dashboardData.stats.totalProducts}</span>
//                   </div>
//                   <div className="flex justify-between items-center mb-3">
//                     <span className="text-sm text-gray-500">Low Stock Items</span>
//                     <span className="text-lg font-semibold text-yellow-600">{dashboardData.stats.lowStockProducts}</span>
//                   </div>

//                   <div className="mt-5">
//                     <div className="flex justify-between items-center mb-1">
//                       <span className="text-xs text-gray-500">Inventory Health</span>
//                       <span className="text-xs font-medium text-green-600">
//                         {
//                           dashboardData.stats.lowStockProducts / dashboardData.stats.totalProducts < 0.1
//                             ? 'Excellent'
//                             : dashboardData.stats.lowStockProducts / dashboardData.stats.totalProducts < 0.2
//                               ? 'Good'
//                               : 'Needs Attention'
//                         }
//                       </span>
//                     </div>
//                     <div className="w-full bg-gray-200 rounded-full h-2.5">
//                       <div
//                         className={`h-2.5 rounded-full ${dashboardData.stats.lowStockProducts / dashboardData.stats.totalProducts < 0.1
//                           ? 'bg-green-600'
//                           : dashboardData.stats.lowStockProducts / dashboardData.stats.totalProducts < 0.2
//                             ? 'bg-yellow-400'
//                             : 'bg-red-500'
//                           }`}
//                         style={{
//                           width: `${100 - (dashboardData.stats.lowStockProducts / dashboardData.stats.totalProducts * 100)}%`
//                         }}
//                       ></div>
//                     </div>
//                   </div>

//                   <Link
//                     to="/inventory"
//                     className="mt-4 block text-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 transition-all duration-200"
//                   >
//                     Manage Inventory
//                   </Link>
//                 </div>
//               </div>

//               {/* Customer Stats */}
//               <div className="bg-white overflow-hidden shadow-lg rounded-lg transition-shadow duration-300 hover:shadow-xl">
//                 <div className="bg-gradient-to-r from-green-50 to-teal-50 px-4 py-3 border-b border-gray-200">
//                   <h3 className="text-base font-medium text-gray-900 flex items-center">
//                     <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
//                     </svg>
//                     Customer Insights
//                   </h3>
//                 </div>
//                 <div className="px-4 py-4">
//                   <div className="flex justify-between items-center mb-3">
//                     <span className="text-sm text-gray-500">Total Customers</span>
//                     <span className="text-lg font-semibold">{dashboardData.stats.totalCustomers}</span>
//                   </div>
//                   <div className="flex justify-between items-center mb-3">
//                     <span className="text-sm text-gray-500">Avg. Order Value</span>
//                     <span className="text-lg font-semibold">{formatCurrency(dashboardData.stats.averageOrderValue)}</span>
//                   </div>

//                   <div className="mt-5">
//                     <div className="flex justify-between items-center mb-1">
//                       <span className="text-xs text-gray-500">Avg. Satisfaction</span>
//                       <span className="text-xs font-medium text-orange-600">
//                         4.7/5.0
//                       </span>
//                     </div>
//                     <div className="flex">
//                       {[1, 2, 3, 4, 5].map((star) => (
//                         <svg key={star} xmlns="http://www.w3.org/2000/svg" className={`h-5 w-5 ${star <= 4 ? 'text-yellow-400' : 'text-gray-300'}`} viewBox="0 0 20 20" fill="currentColor">
//                           <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
//                         </svg>
//                       ))}
//                     </div>
//                   </div>

//                   <Link
//                     to="/customers"
//                     className="mt-4 block text-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 transition-all duration-200"
//                   >
//                     View Customer Data
//                   </Link>
//                 </div>
//               </div>

//               {/* Order Fulfillment */}
//               <div className="bg-white overflow-hidden shadow-lg rounded-lg transition-shadow duration-300 hover:shadow-xl">
//                 <div className="bg-gradient-to-r from-purple-50 to-indigo-50 px-4 py-3 border-b border-gray-200">
//                   <h3 className="text-base font-medium text-gray-900 flex items-center">
//                     <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2 text-purple-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                       <path d="M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0z" />
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0" />
//                     </svg>
//                     Order Processing
//                   </h3>
//                 </div>
//                 <div className="px-4 py-4">
//                   <div className="grid grid-cols-2 gap-3">
//                     <div className="bg-indigo-50 rounded-lg p-3 text-center">
//                       <span className="block text-xs text-indigo-600 font-medium mb-1">Pending</span>
//                       <span className="text-lg font-bold text-indigo-800">{dashboardData.stats.pendingOrders}</span>
//                     </div>
//                     <div className="bg-orange-50 rounded-lg p-3 text-center">
//                       <span className="block text-xs text-orange-600 font-medium mb-1">Processing</span>
//                       <span className="text-lg font-bold text-orange-800">
//                         {Math.max(0, Math.floor(dashboardData.stats.totalOrders * 0.15))}
//                       </span>
//                     </div>
//                     <div className="bg-purple-50 rounded-lg p-3 text-center">
//                       <span className="block text-xs text-purple-600 font-medium mb-1">Shipped</span>
//                       <span className="text-lg font-bold text-purple-800">
//                         {Math.max(0, Math.floor(dashboardData.stats.totalOrders * 0.25))}
//                       </span>
//                     </div>
//                     <div className="bg-green-50 rounded-lg p-3 text-center">
//                       <span className="block text-xs text-green-600 font-medium mb-1">Delivered</span>
//                       <span className="text-lg font-bold text-green-800">
//                         {Math.max(0, Math.floor(dashboardData.stats.totalOrders * 0.60))}
//                       </span>
//                     </div>
//                   </div>

//                   <div className="mt-4">
//                     <div className="flex justify-between items-center mb-1">
//                       <span className="text-xs text-gray-500">Order Fulfillment Rate</span>
//                       <span className="text-xs font-medium text-green-600">
//                         {Math.min(100, Math.max(0, Math.floor((dashboardData.stats.totalOrders - dashboardData.stats.pendingOrders) / Math.max(1, dashboardData.stats.totalOrders) * 100)))}%
//                       </span>
//                     </div>
//                     <div className="w-full bg-gray-200 rounded-full h-2.5">
//                       <div
//                         className="bg-green-600 h-2.5 rounded-full"
//                         style={{
//                           width: `${Math.min(100, Math.max(0, Math.floor((dashboardData.stats.totalOrders - dashboardData.stats.pendingOrders) / Math.max(1, dashboardData.stats.totalOrders) * 100)))}%`
//                         }}
//                       ></div>
//                     </div>
//                   </div>

//                   <Link
//                     to="/orders"
//                     className="mt-4 block text-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 transition-all duration-200"
//                   >
//                     Process Orders
//                   </Link>
//                 </div>
//               </div>
//             </div>
//           </div>
//         ) : (
//           <div className="py-8 text-center">
//             <svg
//               className="mx-auto h-12 w-12 text-gray-400"
//               fill="none"
//               viewBox="0 0 24 24"
//               stroke="currentColor"
//               aria-hidden="true"
//             >
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 strokeWidth={1}
//                 d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
//               />
//             </svg>
//             <h3 className="mt-2 text-lg font-medium text-gray-900">Welcome to ZoneXVendors!</h3>
//             <p className="mt-1 text-gray-500">Your dashboard will appear here once you have some data.</p>
//             <div className="mt-6 flex justify-center">
//               <Link
//                 to="/inventory/add"
//                 className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-orange-600 hover:bg-orange-700"
//               >
//                 <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
//                   <path fillRule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clipRule="evenodd" />
//                 </svg>
//                 Add Your First Product
//               </Link>
//             </div>
//           </div>
//         )}
//       </div>
//     </DashboardLayout>
//   );
// };

// export default DashboardPage;


// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";
// import { collection, query, where, getDocs, orderBy, limit, Timestamp } from "firebase/firestore";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import DashboardLayout from "../../components/layout/DashboardLayout";
// import StatsCard from "../../components/dashboard/StatsCard";
// import SalesChart from "../../components/dashboard/SalesChart";
// import OrdersTable from "../../components/dashboard/OrdersTable";
// import ProductsTable from "../../components/dashboard/ProductsTable";
// import { useAuth } from "../../contexts/AuthContext";
// import { db } from "../../services/firebase";

// const DashboardPage = () => {
//   const { currentUser, vendorProfile } = useAuth();
//   const [dashboardData, setDashboardData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [dateRange, setDateRange] = useState("week"); // 'day', 'week', 'month', 'year', 'custom'
//   const [customDateRange, setCustomDateRange] = useState([null, null]); // [startDate, endDate]
//   const [startDate, endDate] = customDateRange;

//   // Check if vendor has order management enabled
//   const hasOrderManagement = vendorProfile?.businessType !== 'without-orders';

//   // Calculate date range based on selected option
//   const getDateRangeTimestamp = () => {
//     const now = new Date();
//     let startDate, endDate;

//     if (dateRange === "custom" && customDateRange[0] && customDateRange[1]) {
//       startDate = new Date(customDateRange[0]);
//       endDate = new Date(customDateRange[1]);
//       // Set end date to end of day
//       endDate.setHours(23, 59, 59, 999);
//     } else {
//       endDate = new Date(); // Current time

//       switch (dateRange) {
//         case "day":
//           startDate = new Date(now);
//           startDate.setHours(0, 0, 0, 0);
//           break;
//         case "week":
//           startDate = new Date(now);
//           startDate.setDate(now.getDate() - 7);
//           startDate.setHours(0, 0, 0, 0);
//           break;
//         case "month":
//           startDate = new Date(now);
//           startDate.setMonth(now.getMonth() - 1);
//           startDate.setHours(0, 0, 0, 0);
//           break;
//         case "year":
//           startDate = new Date(now);
//           startDate.setFullYear(now.getFullYear() - 1);
//           startDate.setHours(0, 0, 0, 0);
//           break;
//         default:
//           startDate = new Date(now);
//           startDate.setDate(now.getDate() - 7);
//           startDate.setHours(0, 0, 0, 0);
//       }
//     }

//     return {
//       start: Timestamp.fromDate(startDate),
//       end: Timestamp.fromDate(endDate)
//     };
//   };

//   // Fetch dashboard data from Firestore
//   useEffect(() => {
//     const fetchDashboardData = async () => {
//       if (!currentUser?.uid) return;

//       setLoading(true);
//       setError("");

//       try {
//         const { start, end } = getDateRangeTimestamp();

//         let orders = [];
//         let previousOrders = [];
//         let pendingOrders = 0;
//         let totalCustomers = 0;

//         // Only fetch order data if order management is enabled
//         if (hasOrderManagement) {
//           // Fetch current period orders
//           const ordersQuery = query(
//             collection(db, "orders"),
//             where("vendorId", "==", currentUser.uid),
//             where("createdAt", ">=", start),
//             where("createdAt", "<=", end),
//             orderBy("createdAt", "desc")
//           );

//           const ordersSnapshot = await getDocs(ordersQuery);
//           orders = ordersSnapshot.docs.map(doc => ({
//             id: doc.id,
//             ...doc.data(),
//             date: doc.data().createdAt.toDate().toISOString().split('T')[0]
//           }));

//           // Fetch previous period orders for comparison
//           const periodLength = end.toDate().getTime() - start.toDate().getTime();
//           const prevStart = new Date(start.toDate().getTime() - periodLength);
//           const prevEnd = start.toDate();

//           const prevOrdersQuery = query(
//             collection(db, "orders"),
//             where("vendorId", "==", currentUser.uid),
//             where("createdAt", ">=", Timestamp.fromDate(prevStart)),
//             where("createdAt", "<", Timestamp.fromDate(prevEnd)),
//             orderBy("createdAt", "desc")
//           );

//           const prevOrdersSnapshot = await getDocs(prevOrdersQuery);
//           previousOrders = prevOrdersSnapshot.docs.map(doc => ({
//             id: doc.id,
//             ...doc.data()
//           }));

//           // Get order status counts
//           pendingOrders = orders.filter(order =>
//             order.status === "Pending" || order.status === "Processing"
//           ).length;

//           // Fetch customers (based on unique customer IDs in orders)
//           const uniqueCustomerIds = [...new Set(orders.map(order => order.customerId).filter(Boolean))];
//           totalCustomers = uniqueCustomerIds.length;
//         }

//         // Calculate enhanced statistics
//         const stats = calculateStatistics(orders, previousOrders);

//         // Fetch products
//         const productsQuery = query(
//           collection(db, "products"),
//           where("vendorId", "==", currentUser.uid)
//         );

//         const productsSnapshot = await getDocs(productsQuery);
//         const products = productsSnapshot.docs.map(doc => ({
//           id: doc.id,
//           ...doc.data()
//         }));

//         // Calculate product stats
//         const totalProducts = products.length;
//         const lowStockProducts = products.filter(product =>
//           (product.stock || 0) < (product.lowStockThreshold || 10)
//         ).length;

//         // Get top products by sales
//         const topProducts = products
//           .sort((a, b) => (b.totalSales || 0) - (a.totalSales || 0))
//           .slice(0, 5)
//           .map(product => ({
//             id: product.id,
//             name: product.name,
//             sku: product.sku || 'N/A',
//             stock: product.stock || 0,
//             sales: product.totalSales || 0
//           }));

//         // Prepare sales data for chart with proper grouping
//         const salesByDate = orders.reduce((acc, order) => {
//           const date = order.date;
//           if (!acc[date]) {
//             acc[date] = 0;
//           }
//           acc[date] += order.totalAmount || 0;
//           return acc;
//         }, {});

//         // Fill in missing dates with zero sales
//         const salesData = [];
//         const currentDate = new Date(start.toDate());
//         const endDate = new Date(end.toDate());

//         while (currentDate <= endDate) {
//           const dateStr = currentDate.toISOString().split('T')[0];
//           salesData.push({
//             date: dateStr,
//             sales: salesByDate[dateStr] || 0
//           });
//           currentDate.setDate(currentDate.getDate() + 1);
//         }

//         // Format recent orders for table (only if order management is enabled)
//         const recentOrders = hasOrderManagement ? orders
//           .slice(0, 5)
//           .map(order => ({
//             id: order.id,
//             customerName: order.customerName || 'Unknown',
//             total: order.totalAmount || 0,
//             status: order.status || 'Pending',
//             date: order.date
//           })) : [];

//         // Mock visitor data (replace with actual analytics when available)
//         let visitorsToday = Math.floor(Math.random() * 200) + 50;

//         // Compile dashboard data with enhanced statistics
//         const dashboardData = {
//           stats: {
//             totalSales: stats.totalSales,
//             totalOrders: stats.totalOrders,
//             averageOrderValue: stats.averageOrderValue,
//             totalCustomers,
//             totalProducts,
//             lowStockProducts,
//             pendingOrders,
//             visitorsToday,
//             // Add comparison data
//             salesChange: stats.salesChange,
//             ordersChange: stats.ordersChange,
//             salesTrend: stats.salesTrend,
//             ordersTrend: stats.ordersTrend
//           },
//           salesData: salesData.length > 0 ? salesData : generateMockSalesData(),
//           recentOrders,
//           topProducts
//         };

//         setDashboardData(dashboardData);
//       } catch (error) {
//         console.error("Error fetching dashboard data:", error);
//         setError("Failed to load dashboard data. Please check your connection and try again.");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchDashboardData();
//   }, [currentUser, dateRange, customDateRange, hasOrderManagement]);


//   const calculateStatistics = (orders, previousOrders = []) => {
//     const totalOrders = orders.length;
//     const totalSales = orders.reduce((sum, order) => sum + (order.totalAmount || 0), 0);
//     const averageOrderValue = totalOrders > 0 ? totalSales / totalOrders : 0;

//     // Previous period stats for comparison
//     const prevTotalOrders = previousOrders.length;
//     const prevTotalSales = previousOrders.reduce((sum, order) => sum + (order.totalAmount || 0), 0);

//     // Calculate percentage changes
//     const salesChange = prevTotalSales > 0 ?
//       ((totalSales - prevTotalSales) / prevTotalSales) * 100 : 0;
//     const ordersChange = prevTotalOrders > 0 ?
//       ((totalOrders - prevTotalOrders) / prevTotalOrders) * 100 : 0;

//     return {
//       totalSales,
//       totalOrders,
//       averageOrderValue,
//       salesChange: Math.round(salesChange * 10) / 10, // Round to 1 decimal
//       ordersChange: Math.round(ordersChange * 10) / 10,
//       salesTrend: salesChange >= 0 ? 'up' : 'down',
//       ordersTrend: ordersChange >= 0 ? 'up' : 'down'
//     };
//   };

//   // Generate mock sales data if no orders exist
//   const generateMockSalesData = () => {
//     const data = [];
//     const today = new Date();
//     for (let i = 6; i >= 0; i--) {
//       const date = new Date(today);
//       date.setDate(date.getDate() - i);
//       data.push({
//         date: date.toISOString().split('T')[0],
//         sales: Math.floor(Math.random() * 1500) + 500
//       });
//     }
//     return data;
//   };

//   // Format currency
//   const formatCurrency = (amount) => {
//     return new Intl.NumberFormat("en-IN", {
//       style: "currency",
//       currency: "INR",
//       maximumFractionDigits: 0,
//     }).format(amount);
//   };

//   return (
//     <DashboardLayout>
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         {/* Dashboard Header */}
//         <div className="py-4 border-b border-gray-200">
//           <div className="flex items-center justify-between">
//             <div>
//               <h1 className="text-2xl font-bold text-gray-900">Vendor Dashboard</h1>
//               <p className="mt-1 text-sm text-gray-600">
//                 Welcome back, {vendorProfile?.shopName || currentUser?.displayName || "Vendor"}!
//                 {!hasOrderManagement && (
//                   <span className="ml-2 px-2 py-1 text-xs bg-blue-100 text-blue-700 rounded-full">
//                     Inventory Only Mode
//                   </span>
//                 )}
//               </p>
//             </div>
//             <div className="hidden sm:flex items-center space-x-2 text-sm text-gray-600">
//               <span>{new Date().toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}</span>
//               <span>•</span>
//               <span>Last login: {new Date().toLocaleDateString()}</span>
//             </div>
//           </div>
//         </div>

//         {loading ? (
//           <div className="animate-pulse space-y-6 py-6">
//             <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
//               {[...Array(4)].map((_, index) => (
//                 <div
//                   key={index}
//                   className="bg-white overflow-hidden shadow rounded-lg h-32"
//                 ></div>
//               ))}
//             </div>
//             <div className="bg-white overflow-hidden shadow rounded-lg h-80"></div>
//             <div className="grid grid-cols-1 gap-5 lg:grid-cols-2">
//               <div className="bg-white overflow-hidden shadow rounded-lg h-96"></div>
//               <div className="bg-white overflow-hidden shadow rounded-lg h-96"></div>
//             </div>
//           </div>
//         ) : error ? (
//           <div className="bg-red-50 border border-red-200 rounded-md p-6 my-6">
//             <div className="flex">
//               <div className="flex-shrink-0">
//                 <svg
//                   className="h-6 w-6 text-red-400"
//                   xmlns="http://www.w3.org/2000/svg"
//                   viewBox="0 0 20 20"
//                   fill="currentColor"
//                 >
//                   <path
//                     fillRule="evenodd"
//                     d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
//                     clipRule="evenodd"
//                   />
//                 </svg>
//               </div>
//               <div className="ml-3">
//                 <h3 className="text-lg font-medium text-red-800">Error Loading Dashboard</h3>
//                 <div className="mt-2 text-base text-red-700">
//                   <p>{error}</p>
//                   <button
//                     onClick={() => window.location.reload()}
//                     className="mt-3 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
//                   >
//                     <svg className="mr-2 h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
//                     </svg>
//                     Refresh Page
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         ) : dashboardData ? (
//           <div className="space-y-6 py-6">

//             {/* Quick Actions */}
//             <div className="bg-white overflow-hidden shadow-lg rounded-lg transition-shadow duration-300 hover:shadow-xl">
//               <div className="px-4 py-5 sm:p-6">
//                 <h3 className="text-lg font-medium leading-6 text-gray-900 mb-4">
//                   Quick Actions
//                 </h3>
//                 <div className="grid grid-cols-2 gap-4 sm:grid-cols-2 lg:grid-cols-4">
//                   <Link
//                     to="/inventory/add"
//                     className="flex items-center justify-center px-4 py-4 border border-transparent text-sm font-medium rounded-lg shadow-sm text-white bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 transition-all duration-300"
//                   >
//                     <svg
//                       xmlns="http://www.w3.org/2000/svg"
//                       className="h-5 w-5 mr-2"
//                       viewBox="0 0 20 20"
//                       fill="currentColor"
//                     >
//                       <path
//                         fillRule="evenodd"
//                         d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z"
//                         clipRule="evenodd"
//                       />
//                     </svg>
//                     Add Product
//                   </Link>

//                   <Link
//                     to="/invoices/create"
//                     className="flex items-center justify-center px-4 py-4 border border-transparent text-sm font-medium rounded-lg shadow-sm text-white bg-gradient-to-r from-purple-500 to-purple-600 hover:from-purple-600 hover:to-purple-700 transition-all duration-300"
//                   >
//                     <svg
//                       xmlns="http://www.w3.org/2000/svg"
//                       className="h-5 w-5 mr-2"
//                       viewBox="0 0 20 20"
//                       fill="currentColor"
//                     >
//                       <path d="M4 4a2 2 0 00-2 2v1h16V6a2 2 0 00-2-2H4z" />
//                       <path fillRule="evenodd" d="M18 9H2v5a2 2 0 002 2h12a2 2 0 002-2V9zM4 13a1 1 0 011-1h1a1 1 0 110 2H5a1 1 0 01-1-1zm5-1a1 1 0 100 2h1a1 1 0 100-2H9z" clipRule="evenodd" />
//                     </svg>
//                     Create Invoice
//                   </Link>

//                   <Link
//                     to="/inventory"
//                     className="flex items-center justify-center px-4 py-4 border border-transparent text-sm font-medium rounded-lg shadow-sm text-white bg-gradient-to-r from-yellow-500 to-yellow-600 hover:from-yellow-600 hover:to-yellow-700 transition-all duration-300"
//                   >
//                     <svg
//                       xmlns="http://www.w3.org/2000/svg"
//                       className="h-5 w-5 mr-2"
//                       viewBox="0 0 20 20"
//                       fill="currentColor"
//                     >
//                       <path d="M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zM3 10a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6zM14 9a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1h-2z" />
//                     </svg>
//                     Manage Inventory
//                   </Link>

//                   {/* Only show Process Orders if order management is enabled */}
//                   {hasOrderManagement && (
//                     <Link
//                       to="/orders?status=pending"
//                       className="flex items-center justify-center px-4 py-4 border border-transparent text-sm font-medium rounded-lg shadow-sm text-white bg-gradient-to-r from-indigo-500 to-indigo-600 hover:from-indigo-600 hover:to-indigo-700 transition-all duration-300"
//                     >
//                       <svg
//                         xmlns="http://www.w3.org/2000/svg"
//                         className="h-5 w-5 mr-2"
//                         viewBox="0 0 20 20"
//                         fill="currentColor"
//                       >
//                         <path d="M3 1a1 1 0 000 2h1.22l.305 1.222a.997.997 0 00.01.042l1.358 5.43-.893.892C3.74 11.846 4.632 14 6.414 14H15a1 1 0 000-2H6.414l1-1H14a1 1 0 00.894-.553l3-6A1 1 0 0017 3H6.28l-.31-1.243A1 1 0 005 1H3zM16 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM6.5 18a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" />
//                       </svg>
//                       Process Orders
//                     </Link>
//                   )}

//                   {/* If no order management, show Communication instead */}
//                   {!hasOrderManagement && (
//                     <Link
//                       to="/communication"
//                       className="flex items-center justify-center px-4 py-4 border border-transparent text-sm font-medium rounded-lg shadow-sm text-white bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 transition-all duration-300"
//                     >
//                       <svg
//                         xmlns="http://www.w3.org/2000/svg"
//                         className="h-5 w-5 mr-2"
//                         viewBox="0 0 20 20"
//                         fill="currentColor"
//                       >
//                         <path d="M2 5a2 2 0 012-2h7a2 2 0 012 2v4a2 2 0 01-2 2H9l-3 3v-3H4a2 2 0 01-2-2V5z" />
//                         <path d="M15 7v2a4 4 0 01-4 4H9.828l-1.766 1.767c.28.149.599.233.938.233h2l3 3v-3h2a2 2 0 002-2V9a2 2 0 00-2-2h-1z" />
//                       </svg>
//                       Customer Messages
//                     </Link>
//                   )}
//                 </div>
//               </div>
//             </div>

//             {/* Date range selector - Only show if order management is enabled */}

//               <div className="flex justify-end items-center space-x-4">
//                 <div className="inline-flex shadow-sm rounded-md">
//                   <button
//                     type="button"
//                     className={`px-4 py-2 text-sm font-medium rounded-l-md ${dateRange === "day"
//                       ? "bg-orange-600 text-white"
//                       : "bg-white text-gray-700 hover:bg-gray-50"
//                       } border border-gray-300 focus:z-10 focus:outline-none focus:ring-1 focus:ring-orange-500`}
//                     onClick={() => {
//                       setDateRange("day");
//                       setCustomDateRange([null, null]);
//                     }}
//                   >
//                     Today
//                   </button>
//                   <button
//                     type="button"
//                     className={`px-4 py-2 text-sm font-medium ${dateRange === "week"
//                       ? "bg-orange-600 text-white"
//                       : "bg-white text-gray-700 hover:bg-gray-50"
//                       } border-t border-b border-gray-300 focus:z-10 focus:outline-none focus:ring-1 focus:ring-orange-500`}
//                     onClick={() => {
//                       setDateRange("week");
//                       setCustomDateRange([null, null]);
//                     }}
//                   >
//                     Week
//                   </button>
//                   <button
//                     type="button"
//                     className={`px-4 py-2 text-sm font-medium ${dateRange === "month"
//                       ? "bg-orange-600 text-white"
//                       : "bg-white text-gray-700 hover:bg-gray-50"
//                       } border-t border-b border-gray-300 focus:z-10 focus:outline-none focus:ring-1 focus:ring-orange-500`}
//                     onClick={() => {
//                       setDateRange("month");
//                       setCustomDateRange([null, null]);
//                     }}
//                   >
//                     Month
//                   </button>
//                   <button
//                     type="button"
//                     className={`px-4 py-2 text-sm font-medium rounded-r-md ${dateRange === "year"
//                       ? "bg-orange-600 text-white"
//                       : "bg-white text-gray-700 hover:bg-gray-50"
//                       } border border-gray-300 focus:z-10 focus:outline-none focus:ring-1 focus:ring-orange-500`}
//                     onClick={() => {
//                       setDateRange("year");
//                       setCustomDateRange([null, null]);
//                     }}
//                   >
//                     Year
//                   </button>
//                 </div>
//                 <div className="relative">
//                   <DatePicker
//                     selectsRange={true}
//                     startDate={startDate}
//                     endDate={endDate}
//                     onChange={(update) => {
//                       setCustomDateRange(update);
//                       if (update[0] && update[1]) {
//                         setDateRange("custom");
//                       }
//                     }}
//                     isClearable={true}
//                     placeholderText="Select custom range"
//                     className="px-4 py-2 text-sm font-medium border border-gray-300 rounded-md bg-white text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-1 focus:ring-orange-500"
//                   />
//                 </div>
//               </div>


//             {/* Stats Cards */}
//             <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
//               {hasOrderManagement && (
//                 <StatsCard
//                   title="Total Sales"
//                   value={formatCurrency(dashboardData.stats.totalSales)}
//                   icon={
//                     <svg
//                       xmlns="http://www.w3.org/2000/svg"
//                       className="h-6 w-6 text-orange-600"
//                       fill="none"
//                       viewBox="0 0 24 24"
//                       stroke="currentColor"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
//                       />
//                     </svg>
//                   }
//                   change={dashboardData.stats.salesChange}
//                   trend={dashboardData.stats.salesTrend}
//                 />
//               )}

//               {hasOrderManagement && (
//                 <StatsCard
//                   title="Total Orders"
//                   value={dashboardData.stats.totalOrders}
//                   icon={
//                     <svg
//                       xmlns="http://www.w3.org/2000/svg"
//                       className="h-6 w-6 text-indigo-600"
//                       fill="none"
//                       viewBox="0 0 24 24"
//                       stroke="currentColor"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"
//                       />
//                     </svg>
//                   }
//                   change={dashboardData.stats.ordersChange}
//                   trend={dashboardData.stats.ordersTrend}
//                 />
//               )}

//               <StatsCard
//                 title="Total Products"
//                 value={dashboardData.stats.totalProducts}
//                 icon={
//                   <svg
//                     xmlns="http://www.w3.org/2000/svg"
//                     className="h-6 w-6 text-purple-600"
//                     fill="none"
//                     viewBox="0 0 24 24"
//                     stroke="currentColor"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
//                     />
//                   </svg>
//                 }
//                 change={0}
//                 trend="neutral"
//               />

//               <StatsCard
//                 title="Low Stock Items"
//                 value={dashboardData.stats.lowStockProducts}
//                 icon={
//                   <svg
//                     xmlns="http://www.w3.org/2000/svg"
//                     className="h-6 w-6 text-yellow-600"
//                     fill="none"
//                     viewBox="0 0 24 24"
//                     stroke="currentColor"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.664-.833-2.464 0L3.34 16.5c-.77.833.192 2.5 1.732 2.5z"
//                     />
//                   </svg>
//                 }
//                 change={0}
//                 trend="neutral"
//               />
//             </div>

//             {/* Sales Chart - Only show if order management is enabled */}
//            {/* Sales Chart - Only show if order management is enabled */}

//               <div className="bg-white overflow-hidden shadow-lg rounded-lg transition-shadow duration-300 hover:shadow-xl">
//                 <div className="px-4 py-5 sm:p-6">
//                   <div className="flex items-center justify-between mb-4">
//                     <h3 className="text-lg font-medium leading-6 text-gray-900">
//                       Sales Overview
//                     </h3>
//                     <div className="flex items-center text-sm text-gray-500">
//                       <span className="inline-block w-3 h-3 bg-orange-500 rounded-full mr-1"></span>
//                       <span>Revenue</span>
//                     </div>
//                   </div>
//                   <div className="h-80">
//                     <SalesChart data={dashboardData.salesData} />
//                   </div>
//                 </div>
//               </div>


//             {/* Orders and Products Tables - Conditional based on order management */}
//             <div className={`grid grid-cols-1 gap-6 ${hasOrderManagement ? 'lg:grid-cols-2' : ''}`}>
//               {/* Recent Orders - Only show if order management is enabled */}
//               {hasOrderManagement && (
//                 <div className="bg-white overflow-hidden shadow-lg rounded-lg transition-shadow duration-300 hover:shadow-xl">
//                   <div className="px-4 py-5 sm:px-6 flex justify-between items-center border-b border-gray-200">
//                     <h3 className="text-lg font-medium leading-6 text-gray-900">
//                       Recent Orders
//                     </h3>
//                     <Link
//                       to="/orders"
//                       className="text-sm font-medium text-orange-600 hover:text-orange-500 flex items-center"
//                     >
//                       View all
//                       <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1" viewBox="0 0 20 20" fill="currentColor">
//                         <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
//                       </svg>
//                     </Link>
//                   </div>
//                   <div className="px-4 py-3 sm:px-6">
//                     {dashboardData.recentOrders.length > 0 ? (
//                       <OrdersTable orders={dashboardData.recentOrders} />
//                     ) : (
//                       <div className="py-6 text-center text-gray-500">
//                         <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 mx-auto text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
//                         </svg>
//                         <p className="mt-2">No orders yet</p>
//                         <Link to="/orders/new" className="mt-3 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-orange-600 hover:bg-orange-700">
//                           Create your first order
//                         </Link>
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               )}

//               {/* Top Products */}
//               <div className="bg-white overflow-hidden shadow-lg rounded-lg transition-shadow duration-300 hover:shadow-xl">
//                 <div className="px-4 py-5 sm:px-6 flex justify-between items-center border-b border-gray-200">
//                   <h3 className="text-lg font-medium leading-6 text-gray-900">
//                     Top Products
//                   </h3>
//                   <Link
//                     to="/inventory"
//                     className="text-sm font-medium text-orange-600 hover:text-orange-500 flex items-center"
//                   >
//                     View all
//                     <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1" viewBox="0 0 20 20" fill="currentColor">
//                       <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
//                     </svg>
//                   </Link>
//                 </div>
//                 <div className="px-4 py-3 sm:px-6">
//                   {dashboardData.topProducts.length > 0 ? (
//                     <ProductsTable products={dashboardData.topProducts} />
//                   ) : (
//                     <div className="py-6 text-center text-gray-500">
//                       <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 mx-auto text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
//                       </svg>
//                       <p className="mt-2">No products yet</p>
//                       <Link to="/inventory/add" className="mt-3 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-orange-600 hover:bg-orange-700">
//                         Add your first product
//                       </Link>
//                     </div>
//                   )}
//                 </div>
//               </div>
//             </div>

//             {/* Additional Insights Section */}
//             <div className={`grid grid-cols-1 gap-6 ${hasOrderManagement ? 'lg:grid-cols-3' : 'lg:grid-cols-2'}`}>
//               {/* Inventory Status */}
//               <div className="bg-white overflow-hidden shadow-lg rounded-lg transition-shadow duration-300 hover:shadow-xl">
//                 <div className="bg-gradient-to-r from-orange-50 to-indigo-50 px-4 py-3 border-b border-gray-200">
//                   <h3 className="text-base font-medium text-gray-900 flex items-center">
//                     <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2 text-orange-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
//                     </svg>
//                     Inventory Status
//                   </h3>
//                 </div>
//                 <div className="px-4 py-4">
//                   <div className="flex justify-between items-center mb-3">
//                     <span className="text-sm text-gray-500">Total Products</span>
//                     <span className="text-lg font-semibold">{dashboardData.stats.totalProducts}</span>
//                   </div>
//                   <div className="flex justify-between items-center mb-3">
//                     <span className="text-sm text-gray-500">Low Stock Items</span>
//                     <span className="text-lg font-semibold text-yellow-600">{dashboardData.stats.lowStockProducts}</span>
//                   </div>

//                   <div className="mt-5">
//                     <div className="flex justify-between items-center mb-1">
//                       <span className="text-xs text-gray-500">Inventory Health</span>
//                       <span className="text-xs font-medium text-green-600">
//                         {
//                           dashboardData.stats.totalProducts === 0 ? 'No Products' :
//                           dashboardData.stats.lowStockProducts / dashboardData.stats.totalProducts < 0.1
//                             ? 'Excellent'
//                             : dashboardData.stats.lowStockProducts / dashboardData.stats.totalProducts < 0.2
//                               ? 'Good'
//                               : 'Needs Attention'
//                         }
//                       </span>
//                     </div>
//                     <div className="w-full bg-gray-200 rounded-full h-2.5">
//                       <div
//                         className={`h-2.5 rounded-full ${
//                           dashboardData.stats.totalProducts === 0 ? 'bg-gray-400' :
//                           dashboardData.stats.lowStockProducts / dashboardData.stats.totalProducts < 0.1
//                             ? 'bg-green-600'
//                             : dashboardData.stats.lowStockProducts / dashboardData.stats.totalProducts < 0.2
//                               ? 'bg-yellow-400'
//                               : 'bg-red-500'
//                         }`}
//                         style={{
//                           width: dashboardData.stats.totalProducts === 0 ? '0%' : 
//                             `${100 - (dashboardData.stats.lowStockProducts / dashboardData.stats.totalProducts * 100)}%`
//                         }}
//                       ></div>
//                     </div>
//                   </div>

//                   <Link
//                     to="/inventory"
//                     className="mt-4 block text-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 transition-all duration-200"
//                   >
//                     Manage Inventory
//                   </Link>
//                 </div>
//               </div>

//               {/* Customer Stats - Only show if order management is enabled */}
//               {hasOrderManagement && (
//                 <div className="bg-white overflow-hidden shadow-lg rounded-lg transition-shadow duration-300 hover:shadow-xl">
//                   <div className="bg-gradient-to-r from-green-50 to-teal-50 px-4 py-3 border-b border-gray-200">
//                     <h3 className="text-base font-medium text-gray-900 flex items-center">
//                       <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
//                       </svg>
//                       Customer Insights
//                     </h3>
//                   </div>
//                   <div className="px-4 py-4">
//                     <div className="flex justify-between items-center mb-3">
//                       <span className="text-sm text-gray-500">Total Customers</span>
//                       <span className="text-lg font-semibold">{dashboardData.stats.totalCustomers}</span>
//                     </div>
//                     <div className="flex justify-between items-center mb-3">
//                       <span className="text-sm text-gray-500">Avg. Order Value</span>
//                       <span className="text-lg font-semibold">{formatCurrency(dashboardData.stats.averageOrderValue)}</span>
//                     </div>

//                     <div className="mt-5">
//                       <div className="flex justify-between items-center mb-1">
//                         <span className="text-xs text-gray-500">Avg. Satisfaction</span>
//                         <span className="text-xs font-medium text-orange-600">
//                           4.7/5.0
//                         </span>
//                       </div>
//                       <div className="flex">
//                         {[1, 2, 3, 4, 5].map((star) => (
//                           <svg key={star} xmlns="http://www.w3.org/2000/svg" className={`h-5 w-5 ${star <= 4 ? 'text-yellow-400' : 'text-gray-300'}`} viewBox="0 0 20 20" fill="currentColor">
//                             <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
//                           </svg>
//                         ))}
//                       </div>
//                     </div>

//                     <Link
//                       to="/customers"
//                       className="mt-4 block text-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 transition-all duration-200"
//                     >
//                       View Customer Data
//                     </Link>
//                   </div>
//                 </div>
//               )}

//               {/* Business Analytics - Replaces Order Fulfillment for inventory-only vendors */}
//               {!hasOrderManagement ? (
//                 <div className="bg-white overflow-hidden shadow-lg rounded-lg transition-shadow duration-300 hover:shadow-xl">
//                   <div className="bg-gradient-to-r from-purple-50 to-indigo-50 px-4 py-3 border-b border-gray-200">
//                     <h3 className="text-base font-medium text-gray-900 flex items-center">
//                       <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2 text-purple-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
//                       </svg>
//                       Business Analytics
//                     </h3>
//                   </div>
//                   <div className="px-4 py-4">
//                     <div className="grid grid-cols-2 gap-3">
//                       <div className="bg-indigo-50 rounded-lg p-3 text-center">
//                         <span className="block text-xs text-indigo-600 font-medium mb-1">Product Views</span>
//                         <span className="text-lg font-bold text-indigo-800">{dashboardData.stats.visitorsToday}</span>
//                       </div>
//                       <div className="bg-orange-50 rounded-lg p-3 text-center">
//                         <span className="block text-xs text-orange-600 font-medium mb-1">Inquiries</span>
//                         <span className="text-lg font-bold text-orange-800">
//                           {Math.floor(dashboardData.stats.visitorsToday * 0.15)}
//                         </span>
//                       </div>
//                       <div className="bg-purple-50 rounded-lg p-3 text-center">
//                         <span className="block text-xs text-purple-600 font-medium mb-1">Categories</span>
//                         <span className="text-lg font-bold text-purple-800">
//                           {Math.max(1, Math.floor(dashboardData.stats.totalProducts / 10))}
//                         </span>
//                       </div>
//                       <div className="bg-green-50 rounded-lg p-3 text-center">
//                         <span className="block text-xs text-green-600 font-medium mb-1">Updated Today</span>
//                         <span className="text-lg font-bold text-green-800">
//                           {Math.floor(dashboardData.stats.totalProducts * 0.1)}
//                         </span>
//                       </div>
//                     </div>

//                     <div className="mt-4">
//                       <div className="flex justify-between items-center mb-1">
//                         <span className="text-xs text-gray-500">Catalog Completeness</span>
//                         <span className="text-xs font-medium text-green-600">85%</span>
//                       </div>
//                       <div className="w-full bg-gray-200 rounded-full h-2.5">
//                         <div className="bg-green-600 h-2.5 rounded-full" style={{width: '85%'}}></div>
//                       </div>
//                     </div>

//                     <Link
//                       to="/analytics"
//                       className="mt-4 block text-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 transition-all duration-200"
//                     >
//                       View Analytics
//                     </Link>
//                   </div>
//                 </div>
//               ) : (
//                 /* Order Processing - Only show if order management is enabled */
//                 <div className="bg-white overflow-hidden shadow-lg rounded-lg transition-shadow duration-300 hover:shadow-xl">
//                   <div className="bg-gradient-to-r from-purple-50 to-indigo-50 px-4 py-3 border-b border-gray-200">
//                     <h3 className="text-base font-medium text-gray-900 flex items-center">
//                       <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2 text-purple-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                         <path d="M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0z" />
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0" />
//                       </svg>
//                       Order Processing
//                     </h3>
//                   </div>
//                   <div className="px-4 py-4">
//                     <div className="grid grid-cols-2 gap-3">
//                       <div className="bg-indigo-50 rounded-lg p-3 text-center">
//                         <span className="block text-xs text-indigo-600 font-medium mb-1">Pending</span>
//                         <span className="text-lg font-bold text-indigo-800">{dashboardData.stats.pendingOrders}</span>
//                       </div>
//                       <div className="bg-orange-50 rounded-lg p-3 text-center">
//                         <span className="block text-xs text-orange-600 font-medium mb-1">Processing</span>
//                         <span className="text-lg font-bold text-orange-800">
//                           {Math.max(0, Math.floor(dashboardData.stats.totalOrders * 0.15))}
//                         </span>
//                       </div>
//                       <div className="bg-purple-50 rounded-lg p-3 text-center">
//                         <span className="block text-xs text-purple-600 font-medium mb-1">Shipped</span>
//                         <span className="text-lg font-bold text-purple-800">
//                           {Math.max(0, Math.floor(dashboardData.stats.totalOrders * 0.25))}
//                         </span>
//                       </div>
//                       <div className="bg-green-50 rounded-lg p-3 text-center">
//                         <span className="block text-xs text-green-600 font-medium mb-1">Delivered</span>
//                         <span className="text-lg font-bold text-green-800">
//                           {Math.max(0, Math.floor(dashboardData.stats.totalOrders * 0.60))}
//                         </span>
//                       </div>
//                     </div>

//                     <div className="mt-4">
//                       <div className="flex justify-between items-center mb-1">
//                         <span className="text-xs text-gray-500">Order Fulfillment Rate</span>
//                         <span className="text-xs font-medium text-green-600">
//                           {Math.min(100, Math.max(0, Math.floor((dashboardData.stats.totalOrders - dashboardData.stats.pendingOrders) / Math.max(1, dashboardData.stats.totalOrders) * 100)))}%
//                         </span>
//                       </div>
//                       <div className="w-full bg-gray-200 rounded-full h-2.5">
//                         <div
//                           className="bg-green-600 h-2.5 rounded-full"
//                           style={{
//                             width: `${Math.min(100, Math.max(0, Math.floor((dashboardData.stats.totalOrders - dashboardData.stats.pendingOrders) / Math.max(1, dashboardData.stats.totalOrders) * 100)))}%`
//                           }}
//                         ></div>
//                       </div>
//                     </div>

//                     <Link
//                       to="/orders"
//                       className="mt-4 block text-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 transition-all duration-200"
//                     >
//                       Process Orders
//                     </Link>
//                   </div>
//                 </div>
//               )}
//             </div>
//           </div>
//         ) : (
//           <div className="py-8 text-center">
//             <svg
//               className="mx-auto h-12 w-12 text-gray-400"
//               fill="none"
//               viewBox="0 0 24 24"
//               stroke="currentColor"
//               aria-hidden="true"
//             >
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 strokeWidth={1}
//                 d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
//               />
//             </svg>
//             <h3 className="mt-2 text-lg font-medium text-gray-900">Welcome to ZoneXVendors!</h3>
//             <p className="mt-1 text-gray-500">
//               {hasOrderManagement 
//                 ? "Your dashboard will appear here once you have some data."
//                 : "Your inventory dashboard will appear here once you add products."
//               }
//             </p>
//             <div className="mt-6 flex justify-center">
//               <Link
//                 to="/inventory/add"
//                 className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-orange-600 hover:bg-orange-700"
//               >
//                 <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
//                   <path fillRule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clipRule="evenodd" />
//                 </svg>
//                 Add Your First Product
//               </Link>
//             </div>
//           </div>
//         )}
//       </div>
//     </DashboardLayout>
//   );
// };

// export default DashboardPage;
import React, { useState, useEffect, useMemo, useCallback } from "react";
import { Link } from "react-router-dom";
import { collection, query, where, getDocs, orderBy, Timestamp } from "firebase/firestore";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import DashboardLayout from "../../components/layout/DashboardLayout";
import StatsCard from "../../components/dashboard/StatsCard";
import SalesChart from "../../components/dashboard/SalesChart";
import OrdersTable from "../../components/dashboard/OrdersTable";
import ProductsTable from "../../components/dashboard/ProductsTable";
import { useAuth } from "../../contexts/AuthContext";
import { db } from "../../services/firebase";
import { getReturnStatistics } from '../../services/returnsService';

const DashboardPage = () => {
  const { currentUser, vendorProfile } = useAuth();
  const [rawData, setRawData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [chartLoading, setChartLoading] = useState(false);
  const [error, setError] = useState("");
  const [dateRange, setDateRange] = useState("week");
  const [customDateRange, setCustomDateRange] = useState([null, null]);
  const [selectedKPI, setSelectedKPI] = useState("totalSales");
  const [startDate, endDate] = customDateRange;

  const hasOrderManagement = vendorProfile?.businessType !== 'without-orders';

  useEffect(() => {
    if (hasOrderManagement && selectedKPI === "salesWithGST") {
      setSelectedKPI("sales");
    } else if (!hasOrderManagement && selectedKPI === "sales") {
      setSelectedKPI("salesWithGST");
    }
  }, [hasOrderManagement, selectedKPI]);

  const dateRangeTimestamp = useMemo(() => {
    const now = new Date();
    let startDateCalc, endDateCalc;

    if (dateRange === "custom" && customDateRange[0] && customDateRange[1]) {
      startDateCalc = new Date(customDateRange[0]);
      endDateCalc = new Date(customDateRange[1]);
      endDateCalc.setHours(23, 59, 59, 999);
    } else {
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      endDateCalc = new Date(today);
      endDateCalc.setHours(23, 59, 59, 999);

      switch (dateRange) {
        case "day":
          startDateCalc = new Date(today);
          startDateCalc.setHours(0, 0, 0, 0);
          break;
        case "week":
          startDateCalc = new Date(today);
          startDateCalc.setDate(today.getDate() - 6);
          startDateCalc.setHours(0, 0, 0, 0);
          break;
        case "month":
          startDateCalc = new Date(today);
          startDateCalc.setDate(today.getDate() - 29);
          startDateCalc.setHours(0, 0, 0, 0);
          break;
        case "year":
          startDateCalc = new Date(today);
          startDateCalc.setDate(today.getDate() - 364);
          startDateCalc.setHours(0, 0, 0, 0);
          break;
        default:
          startDateCalc = new Date(today);
          startDateCalc.setDate(today.getDate() - 6);
          startDateCalc.setHours(0, 0, 0, 0);
      }
    }

    return {
      start: Timestamp.fromDate(startDateCalc),
      end: Timestamp.fromDate(endDateCalc)
    };
  }, [dateRange, customDateRange]);

  const filteredData = useMemo(() => {
    if (!rawData) return null;

    const { start, end } = dateRangeTimestamp;
    const startDate = start.toDate();
    const endDate = end.toDate();

    const filteredInvoices = rawData.invoices.filter(invoice => {
      const invoiceDate = invoice.createdAt ? invoice.createdAt.toDate() : new Date(invoice.date);
      return invoiceDate >= startDate && invoiceDate <= endDate;
    });

    const filteredOrders = rawData.orders.filter(order => {
      const orderDate = order.createdAt ? order.createdAt.toDate() : new Date(order.date);
      return orderDate >= startDate && orderDate <= endDate;
    });

    const filteredReturns = (rawData.returns || []).filter(returnItem => {
      if (!returnItem.createdAt) {
        console.log('Return item missing createdAt:', returnItem.id);
        return false;
      }

      let returnDate;
      if (returnItem.createdAt.toDate) {
        returnDate = returnItem.createdAt.toDate();
      } else if (typeof returnItem.createdAt === 'string') {
        returnDate = new Date(returnItem.createdAt);
      } else {
        returnDate = returnItem.createdAt;
      }

      const isInRange = returnDate >= startDate && returnDate <= endDate;
      console.log(`Return ${returnItem.id}: ${returnDate.toISOString().split('T')[0]} in range: ${isInRange}`);
      return isInRange;
    });

    console.log('Filtered returns:', filteredReturns.length, 'out of', (rawData.returns || []).length);

    const periodLength = endDate.getTime() - startDate.getTime();
    const prevStartDate = new Date(startDate.getTime() - periodLength);
    const prevEndDate = startDate;

    const prevInvoices = rawData.invoices.filter(invoice => {
      const invoiceDate = invoice.createdAt ? invoice.createdAt.toDate() : new Date(invoice.date);
      return invoiceDate >= prevStartDate && invoiceDate < prevEndDate;
    });

    const prevOrders = rawData.orders.filter(order => {
      const orderDate = order.createdAt ? order.createdAt.toDate() : new Date(order.date);
      return orderDate >= prevStartDate && orderDate < prevEndDate;
    });

    return {
      invoices: filteredInvoices,
      orders: filteredOrders,
      returns: filteredReturns,
      prevInvoices,
      prevOrders,
      products: rawData.products,
      returnStats: rawData.returnStats
    };
  }, [rawData, dateRangeTimestamp]);

  const dashboardStats = useMemo(() => {
    if (!filteredData) return null;

    const { invoices, orders, prevInvoices, prevOrders, products, returnStats } = filteredData;

    console.log('Calculating stats with:', {
      invoices: invoices.length,
      orders: orders.length,
      products: products.length,
      hasOrderManagement
    });

    if (hasOrderManagement) {
      const totalSales = orders.reduce((sum, order) => sum + (order.totalAmount || order.total || 0), 0);
      const totalOrders = orders.length;
      const prevTotalSales = prevOrders.reduce((sum, order) => sum + (order.totalAmount || order.total || 0), 0);
      const prevTotalOrders = prevOrders.length;

      const salesChange = prevTotalSales > 0 ? ((totalSales - prevTotalSales) / prevTotalSales) * 100 : 0;
      const ordersChange = prevTotalOrders > 0 ? ((totalOrders - prevTotalOrders) / prevTotalOrders) * 100 : 0;

      const pendingOrders = orders.filter(order =>
        order.status === "Pending" || order.status === "Processing"
      ).length;

      const uniqueCustomerIds = [...new Set(orders.map(order => order.customerId).filter(Boolean))];

      return {
        totalSales,
        totalOrders,
        averageOrderValue: totalOrders > 0 ? totalSales / totalOrders : 0,
        salesChange: Math.round(salesChange * 10) / 10,
        ordersChange: Math.round(ordersChange * 10) / 10,
        salesTrend: salesChange >= 0 ? 'up' : 'down',
        ordersTrend: ordersChange >= 0 ? 'up' : 'down',
        pendingOrders,
        totalCustomers: uniqueCustomerIds.length,
        totalProducts: products.length,
        returnedProducts: returnStats?.totalReturns || 0,
        pendingReturns: returnStats?.pendingReturns || 0
      };
    } else {
      const totalSalesWithGST = invoices
        .filter(invoice => invoice.invoiceType === 'with_gst')
        .reduce((sum, invoice) => sum + (invoice.totalAmount || invoice.total || 0), 0);

      const totalSalesWithoutGST = invoices
        .filter(invoice => invoice.invoiceType === 'without_gst')
        .reduce((sum, invoice) => sum + (invoice.totalAmount || invoice.total || 0), 0);

      const totalSales = totalSalesWithGST + totalSalesWithoutGST;

      const prevTotalSalesWithGST = prevInvoices
        .filter(invoice => invoice.invoiceType === 'with_gst')
        .reduce((sum, invoice) => sum + (invoice.totalAmount || invoice.total || 0), 0);

      const prevTotalSalesWithoutGST = prevInvoices
        .filter(invoice => invoice.invoiceType === 'without_gst')
        .reduce((sum, invoice) => sum + (invoice.totalAmount || invoice.total || 0), 0);

      const prevTotalSales = prevTotalSalesWithGST + prevTotalSalesWithoutGST;

      const salesWithGSTChange = prevTotalSalesWithGST > 0 ?
        ((totalSalesWithGST - prevTotalSalesWithGST) / prevTotalSalesWithGST) * 100 : 0;

      const salesWithoutGSTChange = prevTotalSalesWithoutGST > 0 ?
        ((totalSalesWithoutGST - prevTotalSalesWithoutGST) / prevTotalSalesWithoutGST) * 100 : 0;

      const totalSalesChange = prevTotalSales > 0 ?
        ((totalSales - prevTotalSales) / prevTotalSales) * 100 : 0;

      const lowStockProducts = products.filter(product =>
        (product.stock || 0) <= (product.lowStockThreshold || 10)
      ).length;

      const totalItemsSold = invoices.reduce((total, invoice) => {
        if (invoice.items && Array.isArray(invoice.items)) {
          return total + invoice.items.reduce((itemSum, item) => itemSum + (item.quantity || 0), 0);
        }
        return total;
      }, 0);

      console.log('Inventory stats calculated:', {
        totalSalesWithGST,
        totalSalesWithoutGST,
        totalSales,
        totalItemsSold,
        lowStockProducts,
        totalProducts: products.length
      });

      return {
        totalSalesWithGST,
        totalSalesWithoutGST,
        totalSales,
        totalBuyedProducts: totalItemsSold,
        lowStockProducts,
        totalProducts: products.length,
        returnedProducts: returnStats?.totalReturns || 0,
        totalRefundAmount: returnStats?.totalRefundAmount || 0,
        pendingReturns: returnStats?.pendingReturns || 0,
        salesWithGSTChange: Math.round(salesWithGSTChange * 10) / 10,
        salesWithoutGSTChange: Math.round(salesWithoutGSTChange * 10) / 10,
        totalSalesChange: Math.round(totalSalesChange * 10) / 10,
        salesWithGSTTrend: salesWithGSTChange >= 0 ? 'up' : 'down',
        salesWithoutGSTTrend: salesWithoutGSTChange >= 0 ? 'up' : 'down',
        totalSalesTrend: totalSalesChange >= 0 ? 'up' : 'down'
      };
    }
  }, [filteredData, hasOrderManagement]);

  const generateChartData = useMemo(() => {
    if (!filteredData) return [];

    const { invoices, orders, products, returns, returnStats } = filteredData;
    const { start, end } = dateRangeTimestamp;

    const chartData = [];
    const currentDate = new Date(start.toDate());
    const endDateObj = new Date(end.toDate());

    console.log('Generating chart for:', {
      selectedKPI,
      hasOrderManagement,
      dateRange,
      dataPoints: {
        invoices: invoices.length,
        orders: orders.length,
        products: products.length,
        returns: returns.length
      }
    });

    while (currentDate.getTime() <= endDateObj.getTime()) {
      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, '0');
      const day = String(currentDate.getDate()).padStart(2, '0');
      const dateStr = `${year}-${month}-${day}`;
      let value = 0;

      if (hasOrderManagement) {
        const dailyOrders = orders.filter(order => {
          const orderDate = order.createdAt ?
            order.createdAt.toDate().toISOString().split('T')[0] :
            order.date?.split('T')[0] || order.date;
          return orderDate === dateStr;
        });

        const dailyReturns = returns.filter(returnItem => {
          const returnDate = returnItem.createdAt ?
            returnItem.createdAt.toDate().toISOString().split('T')[0] :
            returnItem.date?.split('T')[0] || returnItem.date;
          return returnDate === dateStr;
        });

        switch (selectedKPI) {
          case 'sales':
            value = dailyOrders.reduce((sum, order) => sum + (order.totalAmount || order.total || 0), 0);
            break;
          case 'orders':
            value = dailyOrders.length;
            break;
          case 'returns':
            console.log(`Processing returns for ${dateStr}: found ${dailyReturns.length} returns`);
            value = dailyReturns.length;
            break;
          default:
            value = 0;
        }
      } else {
        const dailyInvoices = invoices.filter(invoice => {
          const invoiceDate = invoice.createdAt ?
            invoice.createdAt.toDate().toISOString().split('T')[0] :
            invoice.date?.split('T')[0] || invoice.date;
          return invoiceDate === dateStr;
        });

        const dailyReturns = returns.filter(returnItem => {
          if (!returnItem.createdAt) return false;

          let returnDateStr;
          if (returnItem.createdAt.toDate) {
            returnDateStr = returnItem.createdAt.toDate().toISOString().split('T')[0];
          } else {
            returnDateStr = new Date(returnItem.createdAt).toISOString().split('T')[0];
          }

          return returnDateStr === dateStr;
        });

        switch (selectedKPI) {
          case 'salesWithGST':
            const gstInvoices = dailyInvoices.filter(invoice => invoice.invoiceType === 'with_gst');
            value = gstInvoices.reduce((sum, invoice) => sum + (invoice.totalAmount || invoice.total || 0), 0);
            break;
          case 'salesWithoutGST':
            const noGstInvoices = dailyInvoices.filter(invoice => invoice.invoiceType === 'without_gst');
            value = noGstInvoices.reduce((sum, invoice) => sum + (invoice.totalAmount || invoice.total || 0), 0);
            break;
          case 'totalSales':
            value = dailyInvoices.reduce((sum, invoice) => sum + (invoice.totalAmount || invoice.total || 0), 0);
            break;
          case 'products':
            value = dailyInvoices.reduce((sum, invoice) => {
              if (!invoice.items || !Array.isArray(invoice.items)) return sum;
              return sum + invoice.items.reduce((itemSum, item) => itemSum + (item.quantity || 0), 0);
            }, 0);
            break;
          case 'lowStock':
            value = products.filter(p => (p.stock || 0) <= (p.lowStockThreshold || 10)).length;
            break;
          case 'returns':
            console.log(`Processing returns for ${dateStr}: checking ${returns.length} total returns`);
            console.log(`Found ${dailyReturns.length} returns for this date`);
            if (dailyReturns.length > 0) {
              console.log('Return IDs for this date:', dailyReturns.map(r => r.id));
            }
            value = dailyReturns.length;
            break;
          default:
            value = 0;
        }
      }

      chartData.push({
        date: dateStr,
        value: value
      });

      currentDate.setDate(currentDate.getDate() + 1);
    }

    console.log(`Generated ${chartData.length} chart points for ${selectedKPI}`);
    console.log('Sample data points:', chartData.slice(0, 5));
    const nonZeroPoints = chartData.filter(d => d.value > 0);
    console.log(`Non-zero data points: ${nonZeroPoints.length}`, nonZeroPoints.slice(0, 3));
    console.log('Chart data generated:', {
      selectedKPI,
      totalPoints: chartData.length,
      dateRange: `${chartData[0]?.date} to ${chartData[chartData.length - 1]?.date}`,
      sampleData: chartData.slice(-3),
      nonZeroPoints: chartData.filter(d => d.value > 0).length
    });
    console.log('Sample return dates:', returns.slice(0, 3).map(r => ({
      id: r.id,
      createdAt: r.createdAt,
      dateStr: r.createdAt && r.createdAt.toDate ?
        r.createdAt.toDate().toISOString().split('T')[0] :
        new Date(r.createdAt).toISOString().split('T')[0]
    })));
    return chartData;
  }, [filteredData, selectedKPI, dateRangeTimestamp, hasOrderManagement]);

  const recentOrdersAndProducts = useMemo(() => {
    if (!filteredData) return { recentOrders: [], topProducts: [] };

    const { orders, invoices, products } = filteredData;

    const recentOrders = hasOrderManagement ? orders
      .slice(0, 5)
      .map(order => ({
        id: order.id,
        customerName: order.customerName || 'Unknown',
        total: order.totalAmount || order.total || 0,
        status: order.status || 'Pending',
        date: order.createdAt ? order.createdAt.toDate().toISOString().split('T')[0] : order.date
      })) : [];

    const topProducts = products
      .map(product => {
        const salesAmount = Number(product.totalSalesAmount) || 
                          Number(product.salesAmount) || 
                          Number(product.totalSales) || 
                          Number(product.revenue) || 
                          0;
        
        const quantitySold = Number(product.sales) || 
                            Number(product.quantitySold) || 
                            Number(product.soldQuantity) || 
                            0;

        return {
          id: product.id,
          name: product.name || 'Unnamed Product',
          sku: product.sku || product.partNumber || 'N/A',
          stock: Number(product.stock) || 0,
          sales: salesAmount,
          quantitySold: quantitySold
        };
      })
      .filter(product => product.sales > 0)
      .sort((a, b) => b.sales - a.sales)
      .slice(0, 5);

    return { recentOrders, topProducts };
  }, [filteredData, hasOrderManagement]);

  const handleDateRangeChange = useCallback((newRange, newCustomRange = [null, null]) => {
    if (newRange !== dateRange ||
        newCustomRange[0]?.getTime() !== customDateRange[0]?.getTime() ||
        newCustomRange[1]?.getTime() !== customDateRange[1]?.getTime()) {
      setDateRange(newRange);
      setCustomDateRange(newCustomRange);
    }
  }, [dateRange, customDateRange]);

  useEffect(() => {
    if (!currentUser?.uid) return;

    const fetchInitialData = async () => {
      setLoading(true);
      setError("");

      try {
        let orders = [];
        let invoices = [];
        let returns = [];
        let returnStats = null;

        try {
          returnStats = await getReturnStatistics();
        } catch (error) {
          console.warn("Error fetching return statistics:", error);
          returnStats = {
            totalReturns: 0,
            pendingReturns: 0,
            approvedReturns: 0,
            rejectedReturns: 0,
            totalRefundAmount: 0,
            returnsByDate: {},
            returnsByReason: {}
          };
        }

        if (hasOrderManagement) {
          try {
            const ordersQuery = query(
              collection(db, "orders"),
              where("vendorId", "==", currentUser.uid),
              orderBy("createdAt", "desc")
            );

            const ordersSnapshot = await getDocs(ordersQuery);
            orders = ordersSnapshot.docs.map(doc => ({
              id: doc.id,
              ...doc.data()
            }));

            console.log(`Fetched ${orders.length} total orders`);
          } catch (orderError) {
            console.warn("Error fetching orders:", orderError);
          }
        } else {
          try {
            const invoicesQuery = query(
              collection(db, "invoices"),
              where("vendorId", "==", currentUser.uid),
              orderBy("createdAt", "desc")
            );

            const invoicesSnapshot = await getDocs(invoicesQuery);
            invoices = invoicesSnapshot.docs.map(doc => ({
              id: doc.id,
              ...doc.data()
            }));

            console.log(`Fetched ${invoices.length} total invoices`);
          } catch (invoiceError) {
            console.warn("Error fetching invoices:", invoiceError);
          }
        }

        const productsQuery = query(
          collection(db, "products"),
          where("vendorId", "==", currentUser.uid)
        );

        const productsSnapshot = await getDocs(productsQuery);
        const products = productsSnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));

        try {
          const returnsQuery = query(
            collection(db, "returns"),
            where("vendorId", "==", currentUser.uid)
          );
          const returnsSnapshot = await getDocs(returnsQuery);
          returns = returnsSnapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
          }))
            .sort((a, b) => {
              const dateA = a.createdAt ? (a.createdAt.toDate ? a.createdAt.toDate() : new Date(a.createdAt)) : new Date(0);
              const dateB = b.createdAt ? (b.createdAt.toDate ? b.createdAt.toDate() : new Date(b.createdAt)) : new Date(0);
              return dateB.getTime() - dateA.getTime();
            });

          console.log(`Fetched ${returns.length} total returns`);
        } catch (returnError) {
          console.warn("Error fetching returns:", returnError);
          returns = [];
        }

        setRawData({
          orders,
          invoices,
          products,
          returns,
          returnStats
        });

      } catch (error) {
        console.error("Error fetching dashboard data:", error);
        setError("Failed to load dashboard data. Please check your connection and try again.");
      } finally {
        setLoading(false);
      }
    };

    fetchInitialData();
  }, [currentUser?.uid, hasOrderManagement]);

  const handleKPIChange = useCallback((newKPI) => {
    if (newKPI !== selectedKPI) {
      setChartLoading(true);
      setSelectedKPI(newKPI);
      setTimeout(() => setChartLoading(false), 200);
    }
  }, [selectedKPI]);

  const formatCurrency = useCallback((amount) => {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: 0,
    }).format(amount);
  }, []);

  const kpiOptions = hasOrderManagement ? [
    { value: 'sales', label: 'Sales Revenue', color: '#3b82f6' },
    { value: 'orders', label: 'Order Count', color: '#10b981' },
    { value: 'returns', label: 'Product Returns', color: '#ef4444' }
  ] : [
    { value: 'totalSales', label: 'Total Sales', color: '#2563eb' },
    { value: 'salesWithGST', label: 'Sales With GST', color: '#3b82f6' },
    { value: 'salesWithoutGST', label: 'Sales Without GST', color: '#10b981' },
    { value: 'products', label: 'Items Sold', color: '#8b5cf6' },
    { value: 'lowStock', label: 'Low Stock Items', color: '#f59e0b' },
    { value: 'returns', label: 'Product Returns', color: '#ef4444' }
  ];

  return (
    <DashboardLayout>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="py-4 border-b border-gray-200">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-2xl font-bold text-gray-900">Vendor Dashboard</h1>
              <p className="mt-1 text-sm text-gray-600">
                Welcome back, {vendorProfile?.shopName || currentUser?.displayName || "Vendor"}!
                {!hasOrderManagement && (
                  <span className="ml-2 px-2 py-1 text-xs bg-blue-100 text-blue-700 rounded-full">
                    Inventory Only Mode
                  </span>
                )}
              </p>
            </div>
            <div className="hidden sm:flex items-center space-x-2 text-sm text-gray-600">
              <span>{new Date().toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}</span>
              <span>•</span>
              <span>Last login: {new Date().toLocaleDateString()}</span>
            </div>
          </div>
        </div>

        {loading ? (
          <div className="animate-pulse space-y-6 py-6">
            <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
              {[...Array(4)].map((_, index) => (
                <div key={index} className="bg-white overflow-hidden shadow rounded-lg h-32"></div>
              ))}
            </div>
            <div className="bg-white overflow-hidden shadow rounded-lg h-80"></div>
          </div>
        ) : error ? (
          <div className="bg-red-50 border border-red-200 rounded-md p-6 my-6">
            <div className="flex">
              <div className="flex-shrink-0">
                <svg className="h-6 w-6 text-red-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                </svg>
              </div>
              <div className="ml-3">
                <h3 className="text-lg font-medium text-red-800">Error Loading Dashboard</h3>
                <div className="mt-2 text-base text-red-700">
                  <p>{error}</p>
                  <button
                    onClick={() => window.location.reload()}
                    className="mt-3 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                  >
                    Refresh Page
                  </button>
                </div>
              </div>
            </div>
          </div>
        ) : dashboardStats ? (
          <div className="space-y-6 py-6">
            <div className="bg-white overflow-hidden shadow-lg rounded-lg transition-shadow duration-300 hover:shadow-xl">
              <div className="px-4 py-5 sm:p-6">
                <h3 className="text-lg font-medium leading-6 text-gray-900 mb-4">Quick Actions</h3>
                <div className="grid grid-cols-2 gap-4 sm:grid-cols-2 lg:grid-cols-4">
                  <Link
                    to="/inventory/add"
                    className="flex items-center justify-center px-4 py-4 border border-transparent text-sm font-medium rounded-lg shadow-sm text-white bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 transition-all duration-300"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clipRule="evenodd" />
                    </svg>
                    Add Product
                  </Link>

                  <Link
                    to="/billing?tab=create"
                    className="flex items-center justify-center px-4 py-4 border border-transparent text-sm font-medium rounded-lg shadow-sm text-white bg-gradient-to-r from-purple-500 to-purple-600 hover:from-purple-600 hover:to-purple-700 transition-all duration-300"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
                      <path d="M4 4a2 2 0 00-2 2v1h16V6a2 2 0 00-2-2H4z" />
                      <path fillRule="evenodd" d="M18 9H2v5a2 2 0 002 2h12a2 2 0 002-2V9zM4 13a1 1 0 011-1h1a1 1 0 110 2H5a1 1 0 01-1-1zm5-1a1 1 0 100 2h1a1 1 0 100-2H9z" clipRule="evenodd" />
                    </svg>
                    Create Invoice
                  </Link>

                  <Link
                    to="/inventory"
                    className="flex items-center justify-center px-4 py-4 border border-transparent text-sm font-medium rounded-lg shadow-sm text-white bg-gradient-to-r from-yellow-500 to-yellow-600 hover:from-yellow-600 hover:to-yellow-700 transition-all duration-300"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
                      <path d="M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zM3 10a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6zM14 9a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1h-2z" />
                    </svg>
                    Manage Inventory
                  </Link>

                  {hasOrderManagement ? (
                    <Link
                      to="/orders?status=pending"
                      className="flex items-center justify-center px-4 py-4 border border-transparent text-sm font-medium rounded-lg shadow-sm text-white bg-gradient-to-r from-indigo-500 to-indigo-600 hover:from-indigo-600 hover:to-indigo-700 transition-all duration-300"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
                        <path d="M3 1a1 1 0 000 2h1.22l.305 1.222a.997.997 0 00.01.042l1.358 5.43-.893.892C3.74 11.846 4.632 14 6.414 14H15a1 1 0 000-2H6.414l1-1H14a1 1 0 00.894-.553l3-6A1 1 0 0017 3H6.28l-.31-1.243A1 1 0 005 1H3zM16 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM6.5 18a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" />
                      </svg>
                      Process Orders
                    </Link>
                  ) : (
                    <Link
                      to="/returns"
                      className="flex items-center justify-center px-4 py-4 border border-transparent text-sm font-medium rounded-lg shadow-sm text-white bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 transition-all duration-300"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 20 20" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 15v-1a4 4 0 00-4-4H8m0 0l3 3m-3-3l3-3m9 14V5a2 2 0 00-2-2H6a2 2 0 00-2 2v16l4-2 4 2 4-2 4 2z" />
                      </svg>
                      Returns
                    </Link>
                  )}
                </div>
              </div>
            </div>

            <div className="flex justify-end items-center space-x-4">
              <div className="inline-flex shadow-sm rounded-md">
                <button
                  type="button"
                  className={`px-4 py-2 text-sm font-medium rounded-l-md ${dateRange === "day" ? "bg-red-600 text-white" : "bg-white text-gray-700 hover:bg-gray-50"} border border-gray-300 focus:z-10 focus:outline-none focus:ring-1 focus:ring-red-500`}
                  onClick={() => handleDateRangeChange("day")}
                >
                  Today
                </button>
                <button
                  type="button"
                  className={`px-4 py-2 text-sm font-medium ${dateRange === "week" ? "bg-red-600 text-white" : "bg-white text-gray-700 hover:bg-gray-50"} border-t border-b border-gray-300 focus:z-10 focus:outline-none focus:ring-1 focus:ring-red-500`}
                  onClick={() => handleDateRangeChange("week")}
                >
                  Week
                </button>
                <button
                  type="button"
                  className={`px-4 py-2 text-sm font-medium ${dateRange === "month" ? "bg-red-600 text-white" : "bg-white text-gray-700 hover:bg-gray-50"} border-t border-b border-gray-300 focus:z-10 focus:outline-none focus:ring-1 focus:ring-red-500`}
                  onClick={() => handleDateRangeChange("month")}
                >
                  Month
                </button>
                <button
                  type="button"
                  className={`px-4 py-2 text-sm font-medium rounded-r-md ${dateRange === "year" ? "bg-red-600 text-white" : "bg-white text-gray-700 hover:bg-gray-50"} border border-gray-300 focus:z-10 focus:outline-none focus:ring-1 focus:ring-red-500`}
                  onClick={() => handleDateRangeChange("year")}
                >
                  Year
                </button>
              </div>
              <div className="relative">
                <DatePicker
                  selectsRange={true}
                  startDate={startDate}
                  endDate={endDate}
                  onChange={(update) => {
                    setCustomDateRange(update);
                    if (update[0] && update[1]) {
                      handleDateRangeChange("custom", update);
                    }
                  }}
                  isClearable={true}
                  placeholderText="Select custom range"
                  className="px-4 py-2 text-sm font-medium border border-gray-300 rounded-md bg-white text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-1 focus:ring-red-500"
                />
              </div>
            </div>

            <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6">
              {hasOrderManagement ? (
                <>
                  <div
                    className="cursor-pointer transition-all duration-200"
                    onClick={() => handleKPIChange('products')}
                  >
                    <StatsCard
                      title="Items Sold"
                      value={dashboardStats.totalBuyedProducts}
                      icon={
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-6 w-6 text-indigo-600"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"
                          />
                        </svg>
                      }
                      change={0}
                      trend="neutral"
                      isSelected={selectedKPI === 'products'}
                    />
                  </div>

                  <div
                    className="cursor-pointer transition-all duration-200"
                    onClick={() => handleKPIChange('orders')}
                  >
                    <StatsCard
                      title="Total Orders"
                      value={dashboardStats.totalOrders}
                      icon={
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-6 w-6 text-indigo-600"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"
                          />
                        </svg>
                      }
                      change={dashboardStats.ordersChange}
                      trend={dashboardStats.ordersTrend}
                      isSelected={selectedKPI === 'orders'}
                    />
                  </div>
                  <StatsCard
                    title="Pending Orders"
                    value={dashboardStats.pendingOrders}
                    icon={
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6 text-yellow-600"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                      </svg>
                    }
                    change={0}
                    trend="neutral"
                  />
                  <StatsCard
                    title="Total Products"
                    value={dashboardStats.totalProducts}
                    icon={
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6 text-purple-600"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
                        />
                      </svg>
                    }
                    change={0}
                    trend="neutral"
                  />
                  <div
                    className="cursor-pointer transition-all duration-200"
                    onClick={() => handleKPIChange('returns')}
                  >
                    <StatsCard
                      title="Total Returns"
                      value={dashboardStats.returnedProducts}
                      icon={
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-6 w-6 text-red-600"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M16 15v-1a4 4 0 00-4-4H8m0 0l3 3m-3-3l3-3m9 14V5a2 2 0 00-2-2H6a2 2 0 00-2 2v16l4-2 4 2 4-2 4 2z"
                          />
                        </svg>
                      }
                      change={0}
                      trend="neutral"
                      isSelected={selectedKPI === 'returns'}
                    />
                  </div>
                </>
              ) : (
                <>
                  <div
                    className="cursor-pointer transition-all duration-200"
                    onClick={() => handleKPIChange('totalSales')}
                  >
                    <StatsCard
                      title="Total Sales"
                      value={formatCurrency(dashboardStats.totalSales)}
                      icon={
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-6 w-6 text-blue-700"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                          />
                        </svg>
                      }
                      change={dashboardStats.totalSalesChange}
                      trend={dashboardStats.totalSalesTrend}
                      isSelected={selectedKPI === 'totalSales'}
                    />
                  </div>
                  <div
                    className="cursor-pointer transition-all duration-200"
                    onClick={() => handleKPIChange('salesWithGST')}
                  >
                    <StatsCard
                      title="Sales (With GST)"
                      value={formatCurrency(dashboardStats.totalSalesWithGST)}
                      icon={
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-6 w-6 text-green-600"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                          />
                        </svg>
                      }
                      change={dashboardStats.salesWithGSTChange}
                      trend={dashboardStats.salesWithGSTTrend}
                      isSelected={selectedKPI === 'salesWithGST'}
                    />
                  </div>
                  <div
                    className="cursor-pointer transition-all duration-200"
                    onClick={() => handleKPIChange('salesWithoutGST')}
                  >
                    <StatsCard
                      title="Sales (Without GST)"
                      value={formatCurrency(dashboardStats.totalSalesWithoutGST)}
                      icon={
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-6 w-6 text-blue-600"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z"
                          />
                        </svg>
                      }
                      change={dashboardStats.salesWithoutGSTChange}
                      trend={dashboardStats.salesWithoutGSTTrend}
                      isSelected={selectedKPI === 'salesWithoutGST'}
                    />
                  </div>
                  <div
                    className="cursor-pointer transition-all duration-200"
                    onClick={() => handleKPIChange('products')}
                  >
                    <StatsCard
                      title="Items Purchased"
                      value={dashboardStats.totalBuyedProducts}
                      icon={
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-6 w-6 text-indigo-600"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"
                          />
                        </svg>
                      }
                      change={0}
                      trend="neutral"
                      isSelected={selectedKPI === 'products'}
                    />
                  </div>
                  <div
                    className="cursor-pointer transition-all duration-200"
                    onClick={() => handleKPIChange('lowStock')}
                  >
                    <StatsCard
                      title="Low Stock Items"
                      value={dashboardStats.lowStockProducts}
                      icon={
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-6 w-6 text-yellow-600"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.664-.833-2.464 0L3.34 16.5c-.77.833.192 2.5 1.732 2.5z"
                          />
                        </svg>
                      }
                      change={0}
                      trend="neutral"
                      isSelected={selectedKPI === 'lowStock'}
                    />
                  </div>
                  <div
                    className="cursor-pointer transition-all duration-200"
                    onClick={() => handleKPIChange('returns')}
                  >
                    <StatsCard
                      title="Total Returns"
                      value={dashboardStats.returnedProducts}
                      icon={
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-6 w-6 text-red-600"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M16 15v-1a4 4 0 00-4-4H8m0 0l3 3m-3-3l3-3m9 14V5a2 2 0 00-2-2H6a2 2 0 00-2 2v16l4-2 4 2 4-2 4 2z"
                          />
                        </svg>
                      }
                      change={0}
                      trend="neutral"
                      isSelected={selectedKPI === 'returns'}
                    />
                  </div>
                </>
              )}
            </div>

            <div className="bg-white overflow-hidden shadow-lg rounded-lg transition-shadow duration-300 hover:shadow-xl">
              <div className="px-4 py-5 sm:p-6">
                <div className="flex items-center justify-between mb-4">
                  <h3 className="text-lg font-medium leading-6 text-gray-900">
                    {kpiOptions.find(option => option.value === selectedKPI)?.label || 'Analytics'} Overview
                  </h3>
                  <div className="flex items-center text-sm text-gray-500">
                    <span
                      className="inline-block w-3 h-3 rounded-full mr-1"
                      style={{ backgroundColor: kpiOptions.find(option => option.value === selectedKPI)?.color || '#3b82f6' }}
                    ></span>
                    <span>{kpiOptions.find(option => option.value === selectedKPI)?.label}</span>
                  </div>
                </div>
                <div className="h-80">
                  {chartLoading ? (
                    <div className="flex items-center justify-center h-full">
                      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-red-600"></div>
                    </div>
                  ) : (
                    <SalesChart
                      data={generateChartData}
                      dataKey="value"
                      color={kpiOptions.find(option => option.value === selectedKPI)?.color || '#3b82f6'}
                    />
                  )}
                </div>
              </div>
            </div>

            <div className={`grid grid-cols-1 gap-6 ${hasOrderManagement ? 'lg:grid-cols-2' : ''}`}>
              {hasOrderManagement && (
                <div className="bg-white overflow-hidden shadow-lg rounded-lg transition-shadow duration-300 hover:shadow-xl">
                  <div className="px-4 py-5 sm:px-6 flex justify-between items-center border-b border-gray-200">
                    <h3 className="text-lg font-medium leading-6 text-gray-900">Recent Orders</h3>
                    <Link to="/orders" className="text-sm font-medium text-red-600 hover:text-red-500 flex items-center">
                      View all
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                      </svg>
                    </Link>
                  </div>
                  <div className="px-4 py-3 sm:px-6">
                    {recentOrdersAndProducts.recentOrders.length > 0 ? (
                      <OrdersTable orders={recentOrdersAndProducts.recentOrders} />
                    ) : (
                      <div className="py-6 text-center text-gray-500">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 mx-auto text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                        </svg>
                        <p className="mt-2">No orders in selected period</p>
                      </div>
                    )}
                  </div>
                </div>
              )}

              <div className="bg-white overflow-hidden shadow-lg rounded-lg transition-shadow duration-300 hover:shadow-xl">
                <div className="px-4 py-5 sm:px-6 flex justify-between items-center border-b border-gray-200">
                  <h3 className="text-lg font-medium leading-6 text-gray-900">Top Products</h3>
                  <Link to="/inventory" className="text-sm font-medium text-red-600 hover:text-red-500 flex items-center">
                    View all
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                    </svg>
                  </Link>
                </div>
                <div className="px-4 py-3 sm:px-6">
                  {recentOrdersAndProducts.topProducts.length > 0 ? (
                    <ProductsTable products={recentOrdersAndProducts.topProducts} />
                  ) : (
                    <div className="py-6 text-center text-gray-500">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 mx-auto text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                      </svg>
                      <p className="mt-2">No products yet</p>
                      <Link to="/inventory/add" className="mt-3 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-red-600 hover:bg-red-700">
                        Add your first product
                      </Link>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {!hasOrderManagement && (
              <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
                <div className="bg-white overflow-hidden shadow-lg rounded-lg transition-shadow duration-300 hover:shadow-xl">
                  <div className="bg-gradient-to-r from-red-50 to-indigo-50 px-4 py-3 border-b border-gray-200">
                    <h3 className="text-base font-medium text-gray-900 flex items-center">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                      </svg>
                      Inventory Status
                    </h3>
                  </div>
                  <div className="px-4 py-4">
                    <div className="flex justify-between items-center mb-3">
                      <span className="text-sm text-gray-500">Total Products</span>
                      <span className="text-lg font-semibold">{dashboardStats.totalProducts}</span>
                    </div>
                    <div className="flex justify-between items-center mb-3">
                      <span className="text-sm text-gray-500">Low Stock Items</span>
                      <span className="text-lg font-semibold text-yellow-600">{dashboardStats.lowStockProducts}</span>
                    </div>

                    <div className="mt-5">
                      <div className="flex justify-between items-center mb-1">
                        <span className="text-xs text-gray-500">Inventory Health</span>
                        <span className="text-xs font-medium text-green-600">
                          {
                            dashboardStats.lowStockProducts / dashboardStats.totalProducts < 0.1
                              ? 'Excellent'
                              : dashboardStats.lowStockProducts / dashboardStats.totalProducts < 0.2
                                ? 'Good'
                                : 'Needs Attention'
                          }
                        </span>
                      </div>
                      <div className="w-full bg-gray-200 rounded-full h-2.5">
                        <div
                          className={`h-2.5 rounded-full ${dashboardStats.lowStockProducts / dashboardStats.totalProducts < 0.1
                            ? 'bg-green-600'
                            : dashboardStats.lowStockProducts / dashboardStats.totalProducts < 0.2
                              ? 'bg-yellow-400'
                              : 'bg-red-500'
                            }`}
                          style={{
                            width: `${100 - (dashboardStats.lowStockProducts / dashboardStats.totalProducts * 100)}%`
                          }}
                        ></div>
                      </div>
                    </div>

                    <Link
                      to="/inventory"
                      className="mt-4 block text-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 transition-all duration-200"
                    >
                      Manage Inventory
                    </Link>
                  </div>
                </div>

                <div className="bg-white overflow-hidden shadow-lg rounded-lg transition-shadow duration-300 hover:shadow-xl">
                  <div className="bg-gradient-to-r from-purple-50 to-indigo-50 px-4 py-3 border-b border-gray-200">
                    <h3 className="text-base font-medium text-gray-900 flex items-center">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2 text-purple-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                      </svg>
                      Business Analytics
                    </h3>
                  </div>
                  <div className="px-4 py-4">
                    <div className="grid grid-cols-2 gap-3">
                      <div className="bg-indigo-50 rounded-lg p-3 text-center">
                        <span className="block text-xs text-indigo-600 font-medium mb-1">Categories</span>
                        <span className="text-lg font-bold text-indigo-800">
                          {Math.max(1, Math.floor(dashboardStats.totalProducts / 10))}
                        </span>
                      </div>
                      <div className="bg-green-50 rounded-lg p-3 text-center">
                        <span className="block text-xs text-green-600 font-medium mb-1">Active</span>
                        <span className="text-lg font-bold text-green-800">
                          {Math.floor(dashboardStats.totalProducts * 0.9)}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        ) : (
          <div className="py-8 text-center">
            <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
            <h3 className="mt-2 text-lg font-medium text-gray-900">Welcome to ZoneXVendors!</h3>
            <p className="mt-1 text-gray-500">
              {hasOrderManagement
                ? "Your dashboard will appear here once you have some data."
                : "Your inventory dashboard will appear here once you add products."
              }
            </p>
            <div className="mt-6 flex justify-center">
              <Link
                to="/inventory/add"
                className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-red-600 hover:bg-red-700"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clipRule="evenodd" />
                </svg>
                Add Your First Product
              </Link>
            </div>
          </div>
        )}
      </div>
    </DashboardLayout>
  );
};

export default DashboardPage;